import React, { useState } from 'react';
import { getAPI } from '../../utils/config';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { API } from '../../utils/config';
import { useTranslation } from 'react-i18next';

// Message templates for each occasion (50 each)
const MESSAGE_TEMPLATES = {
  birthday: [
    "Wishing you a day filled with love, laughter, and unforgettable moments. Happy Birthday, {recipient}!",
    "May your special day be as wonderful as you are. Enjoy every moment!",
    "Another year older, another year of amazing memories. Celebrate big, {recipient}!",
    "Sending you warm wishes and endless smiles on your birthday. You deserve the best!",
    "Here's to a year filled with new adventures and cherished memories. Happy Birthday!",
    "Your birthday is the perfect time to celebrate the amazing person you are!",
    "May this year bring you closer to your dreams. Have a fantastic birthday, {recipient}!",
    "Cheers to another trip around the sun! Make it count!",
    "Today is all about you! Enjoy every second of your special day.",
    "Wishing you joy, laughter, and wonderful surprises on your birthday!",
    "Another year, another reason to celebrate how incredible you are!",
    "May your birthday be filled with precious moments you'll treasure forever.",
    "Sending you love and happiness on your special day. You mean the world to us!",
    "Here's to making this birthday your best one yet!",
    "Celebrating you today and always. Happy Birthday, {recipient}!",
    "May your day be as bright and beautiful as your smile!",
    "Another year of being absolutely amazing! Happy Birthday!",
    "Wishing you a birthday as special as the memories we share.",
    "May this year bring you everything your heart desires. Enjoy your day!",
    "Cheers to you and all the joy you bring to our lives. Happy Birthday!",
    "Your birthday is a reminder of how grateful we are to have you in our lives.",
    "May your special day be filled with love, laughter, and cake!",
    "Here's to celebrating another year of you being you - which is pretty wonderful!",
    "Wishing you a birthday filled with magic and wonder. You deserve it all!",
    "May this year be your best chapter yet. Happy Birthday, {recipient}!",
    "Celebrating the gift that you are to everyone around you!",
    "Another year older, wiser, and more fabulous! Enjoy your day!",
    "May your birthday be the start of a year filled with good luck and happiness.",
    "Sending you big hugs and warm wishes on your special day!",
    "You make the world brighter just by being in it. Happy Birthday!",
    "May your day be filled with sweet surprises and joyful moments.",
    "Here's to another year of making beautiful memories together!",
    "Wishing you a birthday that's as amazing as you are!",
    "May your special day bring you as much happiness as you bring to others.",
    "Cheers to you and the wonderful journey ahead. Happy Birthday!",
    "Another year to shine bright and spread your joy. Celebrate yourself today!",
    "May your birthday be filled with all the things that make you smile.",
    "Sending you love, light, and laughter on your special day!",
    "Here's to celebrating you and all the incredible things you do!",
    "May this birthday mark the beginning of your most amazing year yet!",
    "Wishing you a day as wonderful as the memories we'll create together.",
    "You're not getting older, you're getting better! Happy Birthday!",
    "May your birthday be sprinkled with fun and laughter. Enjoy every moment!",
    "Celebrating the amazing person you are today and always!",
    "May this year bring you endless reasons to smile. Happy Birthday, {recipient}!",
    "Here's to another year of adventures, laughter, and unforgettable moments!",
    "Your birthday is a celebration of all the joy you bring to our lives.",
    "Wishing you a birthday filled with love, happiness, and all your favorite things!",
    "May your special day be just the beginning of a year filled with happy moments!",
    "Cheers to you and the beautiful memories we'll make together. Happy Birthday!"
  ],
  holiday: [
    "May this holiday season fill your heart with warmth and joy. Happy Holidays, {recipient}!",
    "Wishing you peace, love, and happiness this holiday season.",
    "May your holidays sparkle with moments of love, laughter, and goodwill.",
    "Sending you warm wishes for a wonderful holiday season!",
    "May the magic of the holidays bring you joy that lasts all year long.",
    "Here's to a season filled with cozy moments and cherished memories!",
    "Wishing you and yours a holiday season full of blessings.",
    "May your holidays be merry, bright, and filled with love!",
    "Sending you holiday cheer and warm wishes from our family to yours.",
    "May this festive season bring you closer to those you love most.",
    "Wishing you a holiday season wrapped in happiness and tied with love.",
    "May your holidays be filled with the warmth of family and friends.",
    "Here's to celebrating the season with joy in our hearts!",
    "May the spirit of the holidays fill your home with peace and love.",
    "Wishing you magical moments and beautiful memories this holiday season!",
    "May your holidays be as bright as the love we share. Happy Holidays!",
    "Sending you wishes for a season of wonder and delight!",
    "May the joy of the holidays stay with you throughout the year.",
    "Here's to a holiday season filled with laughter and love!",
    "Wishing you peace and happiness during this special time of year.",
    "May your holidays be blessed with the company of loved ones.",
    "Sending you warm hugs and holiday wishes, {recipient}!",
    "May this season bring you countless reasons to smile and celebrate!",
    "Wishing you a holiday season that warms your heart and lifts your spirit.",
    "May the beauty of the holidays fill your life with joy.",
    "Here's to making wonderful holiday memories together!",
    "May your season be merry and your heart be light!",
    "Wishing you all the magic and wonder the holidays can bring.",
    "May this festive season bring you closer to everything you hold dear.",
    "Sending you love and light this holiday season and always!",
    "May your holidays be filled with moments that become treasured memories.",
    "Wishing you a season of joy, a season of love, a season of blessings!",
    "May the holidays bring you peace, love, and endless happiness.",
    "Here's to celebrating the season with gratitude and joy!",
    "May your holiday season be wrapped in warmth and filled with love.",
    "Wishing you comfort, joy, and all the happiness this season can hold!",
    "May the spirit of giving fill your heart this holiday season.",
    "Sending you warm wishes for a bright and joyful holiday!",
    "May this season remind you of all the blessings in your life.",
    "Wishing you a holiday season as wonderful as you are, {recipient}!",
    "May your holidays be touched with the magic of love and togetherness.",
    "Here's to celebrating the joy of the season with those we love!",
    "May your heart be filled with the true meaning of the holidays.",
    "Wishing you peaceful moments and joyful celebrations this season!",
    "May the holidays bring you beautiful memories to cherish forever.",
    "Sending you wishes for a season filled with love, laughter, and light!",
    "May your holidays be blessed with the presence of loved ones.",
    "Wishing you a season of happiness and a new year of peace!",
    "May the joy and wonder of the holidays be yours today and always!",
    "Here's to a holiday season that fills your heart with warmth and wonder!"
  ],
  anniversary: [
    "Celebrating the beautiful journey you've shared together. Happy Anniversary, {recipient}!",
    "Here's to another year of love, laughter, and unforgettable memories!",
    "May your love continue to grow stronger with each passing year.",
    "Wishing you both endless happiness on your special day!",
    "Your love story inspires us all. Happy Anniversary!",
    "May your anniversary be filled with sweet memories and dreams of tomorrow.",
    "Here's to the love that keeps getting better with time!",
    "Celebrating the bond you share and the memories you've created together.",
    "May your love continue to bloom and flourish. Happy Anniversary!",
    "Wishing you a day filled with love, joy, and beautiful moments together.",
    "Your love is a beautiful example of what true partnership means.",
    "May this anniversary mark another chapter in your amazing love story!",
    "Here's to many more years of happiness, love, and togetherness!",
    "Celebrating the day when two hearts became one. Happy Anniversary!",
    "May your love continue to be a source of joy and strength.",
    "Wishing you both a lifetime of love and happiness together!",
    "Your journey together is an inspiration to us all. Happy Anniversary!",
    "May your anniversary be as special as the love you share.",
    "Here's to another year of creating beautiful memories together!",
    "Celebrating the enduring love between two amazing people!",
    "May your love story continue to inspire and bring joy to others.",
    "Wishing you a day as beautiful as your love for each other!",
    "Your love grows more beautiful with each passing year. Happy Anniversary!",
    "May this special day remind you of all the reasons you fell in love.",
    "Here's to celebrating the love that makes life so wonderful!",
    "May your anniversary be filled with romance, laughter, and joy!",
    "Wishing you endless love and happiness on your special day, {recipient}!",
    "Your love is a testament to what true commitment looks like.",
    "May you continue to find new reasons to love each other every day!",
    "Here's to another year of growing together and loving deeper!",
    "Celebrating the beautiful life you've built together. Happy Anniversary!",
    "May your love continue to shine as bright as it did on day one.",
    "Wishing you both a lifetime of adventures and cherished moments!",
    "Your love story is proof that true love exists. Happy Anniversary!",
    "May this anniversary be a celebration of all you mean to each other.",
    "Here's to the love that conquers all and grows stronger each day!",
    "May your hearts always beat as one. Happy Anniversary!",
    "Wishing you a day filled with the love and joy you bring to each other!",
    "Your partnership is a beautiful gift. Happy Anniversary!",
    "May your love continue to be an anchor and a light in your lives.",
    "Here's to celebrating another year of your incredible journey together!",
    "May your anniversary be as magical as the day you first met!",
    "Wishing you endless moments of love and happiness together!",
    "Your love is an inspiration and a blessing. Happy Anniversary!",
    "May you continue to write beautiful chapters in your love story!",
    "Here's to the love that makes every day brighter. Happy Anniversary!",
    "May your anniversary be a sweet reminder of your beautiful journey!",
    "Wishing you both all the love your hearts can hold today and always!",
    "Your love story is my favorite. Happy Anniversary, {recipient}!",
    "May your anniversary be filled with all the love you've given each other!"
  ],
  celebration: [
    "Congratulations on this amazing achievement! You deserve all the success, {recipient}!",
    "Your hard work and dedication have paid off. Celebrating your success!",
    "Here's to your incredible accomplishment! Well done!",
    "You did it! Wishing you continued success and happiness!",
    "Celebrating this wonderful milestone with you. Congratulations!",
    "Your achievement is truly inspiring. Keep reaching for the stars!",
    "Congratulations! May this be just the beginning of even greater things!",
    "You've earned every bit of this success. Celebrate big!",
    "Here's to your amazing accomplishment and the journey that got you here!",
    "Congratulations on reaching this incredible milestone, {recipient}!",
    "Your success is well-deserved. Wishing you all the best!",
    "Celebrating your achievement and all the hard work behind it!",
    "You're proof that dreams do come true. Congratulations!",
    "May this success open doors to even more amazing opportunities!",
    "Here's to celebrating you and this fantastic achievement!",
    "Your dedication has led to this moment. Congratulations!",
    "Wishing you continued success in all your future endeavors!",
    "You've made us all so proud. Celebrate this special moment!",
    "Congratulations on this well-deserved success! Keep shining!",
    "Your achievement is a testament to your hard work and passion!",
    "Here's to celebrating this milestone and many more to come!",
    "You did it! May this be the first of many successes!",
    "Congratulations! Your success inspires everyone around you!",
    "Celebrating this amazing achievement with you today!",
    "You've worked so hard for this. Enjoy every moment of your success!",
    "Here's to your fantastic accomplishment! Well done, {recipient}!",
    "Congratulations on this incredible milestone in your journey!",
    "Your success is a reflection of your determination and talent!",
    "Wishing you continued happiness and success in all you do!",
    "You deserve all the recognition and celebration today!",
    "Here's to achieving greatness and celebrating your success!",
    "Congratulations! May your future be as bright as this moment!",
    "Your hard work has led to this wonderful achievement!",
    "Celebrating your success and the exciting journey ahead!",
    "You've reached an amazing milestone. Congratulations!",
    "Here's to your success today and all your future accomplishments!",
    "Congratulations on this achievement that was so well-earned!",
    "Your success story is truly inspiring. Keep reaching higher!",
    "Wishing you joy and pride in this wonderful accomplishment!",
    "Here's to celebrating this special moment with you, {recipient}!",
    "Congratulations! Your dedication has brought you this success!",
    "May this achievement be a stepping stone to even greater things!",
    "You've accomplished something truly special. Congratulations!",
    "Here's to your success and all the exciting possibilities ahead!",
    "Congratulations on reaching this incredible goal!",
    "Your achievement fills us with pride and joy. Well done!",
    "Here's to celebrating your success and the journey that continues!",
    "Congratulations! May your future be filled with more amazing moments!",
    "Your success is a beautiful reminder that hard work pays off!",
    "Here's to this achievement and all the wonderful things to come!"
  ],
  thankyou: [
    "Thank you for being such an amazing part of my life, {recipient}!",
    "Your kindness and support mean more than words can express. Thank you!",
    "I'm so grateful to have you in my life. Thank you for everything!",
    "Your generosity and thoughtfulness never cease to amaze me. Thank you!",
    "Thank you for always being there when I need you most!",
    "I couldn't have done it without you. Thank you from the bottom of my heart!",
    "Your support has made all the difference. Thank you so much!",
    "Thank you for being such a wonderful friend and inspiration!",
    "I'm blessed to have someone as caring as you in my life. Thank you!",
    "Your kindness has touched my heart in so many ways. Thank you!",
    "Thank you for bringing so much joy and light into my life!",
    "I appreciate everything you do more than you know. Thank you, {recipient}!",
    "Your thoughtfulness never goes unnoticed. Thank you for being you!",
    "Thank you for your endless support and encouragement!",
    "I'm so grateful for your friendship and all you do. Thank you!",
    "Thank you for always knowing exactly what to say and do!",
    "Your generosity has meant the world to me. Thank you so much!",
    "Thank you for being my rock and my inspiration!",
    "I can't thank you enough for all your help and support!",
    "Your kindness has made such a difference in my life. Thank you!",
    "Thank you for being such a beautiful soul and wonderful friend!",
    "I'm forever grateful for everything you've done for me. Thank you!",
    "Thank you for your unwavering support and belief in me!",
    "Your friendship is a gift I treasure every day. Thank you!",
    "Thank you for making life so much brighter and better!",
    "I'm so lucky to have you in my corner. Thank you, {recipient}!",
    "Your help came exactly when I needed it most. Thank you!",
    "Thank you for being someone I can always count on!",
    "Your kindness and compassion inspire me every day. Thank you!",
    "Thank you for all the little things that mean so much!",
    "I appreciate your friendship more than words can say. Thank you!",
    "Thank you for being a constant source of support and joy!",
    "Your thoughtfulness has touched my heart deeply. Thank you!",
    "Thank you for always going above and beyond!",
    "I'm so grateful for your presence in my life. Thank you!",
    "Thank you for being such an incredible human being!",
    "Your generosity knows no bounds. Thank you so much, {recipient}!",
    "Thank you for making the world a better place just by being in it!",
    "I couldn't ask for a better friend. Thank you for everything!",
    "Your support has meant everything to me. Thank you!",
    "Thank you for being my cheerleader and my comfort!",
    "I'm so thankful for your kindness and caring heart!",
    "Thank you for all the ways you make my life better!",
    "Your friendship is one of my greatest blessings. Thank you!",
    "Thank you for being there through thick and thin!",
    "I appreciate you more than you'll ever know. Thank you, {recipient}!",
    "Thank you for your patience, understanding, and love!",
    "Your impact on my life is immeasurable. Thank you!",
    "Thank you for being exactly who you are - wonderful!",
    "I'm forever grateful for your friendship and support. Thank you!"
  ],
  mothers_day: [
    "Happy Mother's Day to the most amazing mom! Thank you for everything you do, {recipient}!",
    "To the woman who gave me life and taught me how to live it - Happy Mother's Day!",
    "Your love, strength, and wisdom inspire me every day. Happy Mother's Day, Mom!",
    "Thank you for being my first teacher, my best friend, and my biggest supporter!",
    "Happy Mother's Day to the queen of our family. We love you endlessly!",
    "Your hugs are my safe place, your smile is my sunshine. Happy Mother's Day!",
    "To the world's greatest mom - thank you for making our house a home!",
    "Happy Mother's Day! Your love has shaped who I am today.",
    "Mom, you're my hero, my role model, and my inspiration. Love you always!",
    "Celebrating you today and every day. Happy Mother's Day, {recipient}!",
    "Your sacrifices haven't gone unnoticed. Thank you for everything, Mom!",
    "Happy Mother's Day to the woman who can do it all with grace and love!",
    "Thank you for being the heart of our family. Happy Mother's Day!",
    "Your love is the foundation of everything good in my life. Happy Mother's Day!",
    "To the best mom in the world - you deserve all the love today and always!",
    "Happy Mother's Day! Your strength and kindness amaze me every day.",
    "Thank you for the countless ways you show your love. Happy Mother's Day, Mom!",
    "You're not just my mother, you're my best friend. Happy Mother's Day!",
    "Your wisdom guides me, your love sustains me. Happy Mother's Day, {recipient}!",
    "Happy Mother's Day to the woman who taught me what unconditional love means!",
    "Mom, your love is the greatest gift I've ever received. Happy Mother's Day!",
    "Thank you for always believing in me. Happy Mother's Day to the best!",
    "Your patience, love, and support mean everything to me. Happy Mother's Day!",
    "Happy Mother's Day! You make every day brighter just by being you.",
    "To my first friend and forever confidant - Happy Mother's Day, Mom!",
    "Your love is my anchor and my wings. Happy Mother's Day, {recipient}!",
    "Happy Mother's Day to the woman who makes miracles happen every day!",
    "Thank you for your endless love and unwavering support. Happy Mother's Day!",
    "You're the heartbeat of our family. Happy Mother's Day, Mom!",
    "Your love has been my guiding light. Happy Mother's Day to you!",
    "Happy Mother's Day! Your strength inspires me to be better every day.",
    "To the woman who gave me roots and wings - Happy Mother's Day!",
    "Your love is the most precious gift. Happy Mother's Day, {recipient}!",
    "Happy Mother's Day to the most selfless person I know. We love you!",
    "Thank you for teaching me about love, life, and laughter. Happy Mother's Day!",
    "Your hugs heal everything. Happy Mother's Day to the best mom ever!",
    "Happy Mother's Day! You're the reason our family is so blessed.",
    "To my rock, my inspiration, my everything - Happy Mother's Day, Mom!",
    "Your love makes the impossible possible. Happy Mother's Day, {recipient}!",
    "Happy Mother's Day to the woman who does it all and makes it look easy!",
    "Thank you for being my constant source of love and support. Happy Mother's Day!",
    "Your wisdom and grace inspire me daily. Happy Mother's Day, Mom!",
    "Happy Mother's Day! You're the glue that holds our family together.",
    "To the queen of my heart - Happy Mother's Day with all my love!",
    "Your love has shaped my world in the most beautiful ways. Happy Mother's Day!",
    "Happy Mother's Day to my superhero, my best friend, my everything!",
    "Thank you for making every day special with your love. Happy Mother's Day!",
    "Your love is my greatest blessing. Happy Mother's Day, {recipient}!",
    "Happy Mother's Day to the woman whose love knows no bounds!",
    "You're simply the best, Mom. Happy Mother's Day with all my heart!"
  ],
  fathers_day: [
    "Happy Father's Day to my hero, my guide, and my inspiration, {recipient}!",
    "Dad, thank you for always being there. Happy Father's Day!",
    "Your strength and wisdom have shaped who I am. Happy Father's Day!",
    "Happy Father's Day to the man who taught me everything important in life!",
    "Thank you for being my rock and my biggest cheerleader. Happy Father's Day!",
    "Dad, you're my first hero and my forever role model. Happy Father's Day!",
    "Happy Father's Day! Your love and guidance mean the world to me.",
    "To the best dad ever - thank you for all the sacrifices you've made!",
    "Your wisdom, strength, and love inspire me every day. Happy Father's Day!",
    "Happy Father's Day, Dad! You're the foundation of our family.",
    "Thank you for teaching me about integrity, hard work, and love. Happy Father's Day!",
    "Dad, you're my superhero without a cape. Happy Father's Day, {recipient}!",
    "Happy Father's Day to the man who can fix anything and solve everything!",
    "Your guidance has been my compass. Happy Father's Day, Dad!",
    "Thank you for being patient, loving, and always there. Happy Father's Day!",
    "Happy Father's Day! Your strength gives us all courage.",
    "Dad, you're proof that heroes do exist. Happy Father's Day!",
    "Thank you for showing me what it means to be strong and kind. Happy Father's Day!",
    "Your love has been my safety net. Happy Father's Day, {recipient}!",
    "Happy Father's Day to the man who taught me to dream big!",
    "Dad, your wisdom and love have guided me through life. Happy Father's Day!",
    "Thank you for all the life lessons and laughs. Happy Father's Day!",
    "Happy Father's Day! You're the best dad anyone could ask for.",
    "Your support means everything to me. Happy Father's Day, Dad!",
    "Thank you for being my protector and my friend. Happy Father's Day!",
    "Happy Father's Day to the man who makes everything better!",
    "Dad, you're my inspiration and my role model. Happy Father's Day, {recipient}!",
    "Your love and guidance have shaped my life. Happy Father's Day!",
    "Happy Father's Day! Thank you for always believing in me.",
    "To the world's greatest dad - you deserve all the recognition today!",
    "Your strength, wisdom, and love are unmatched. Happy Father's Day!",
    "Happy Father's Day, Dad! You're the backbone of our family.",
    "Thank you for showing me what unconditional love looks like. Happy Father's Day!",
    "Dad, you're my first teacher and my forever hero. Happy Father's Day!",
    "Your guidance has been my greatest gift. Happy Father's Day, {recipient}!",
    "Happy Father's Day to the man who taught me to stand tall!",
    "Thank you for your patience, love, and endless support. Happy Father's Day!",
    "Dad, you make the world a better place. Happy Father's Day!",
    "Your love is my foundation. Happy Father's Day to the best!",
    "Happy Father's Day! You're simply the greatest, Dad.",
    "Thank you for being my anchor and my wings. Happy Father's Day!",
    "Your wisdom lights my path. Happy Father's Day, {recipient}!",
    "Happy Father's Day to my first hero and forever friend!",
    "Dad, your love has made all the difference. Happy Father's Day!",
    "Thank you for being the best example of strength and love. Happy Father's Day!",
    "Your presence in my life is my greatest blessing. Happy Father's Day!",
    "Happy Father's Day to the man who can do anything!",
    "Thank you for all the memories and lessons. Happy Father's Day, Dad!",
    "You're not just my father, you're my inspiration. Happy Father's Day!",
    "Happy Father's Day! Your love and support mean everything to me, {recipient}!"
  ],
  wedding: [
    "Wishing you a lifetime of love and happiness together! Congratulations, {recipient}!",
    "May your love story be filled with joy, laughter, and endless romance!",
    "Congratulations on finding your forever! Wishing you both all the happiness in the world.",
    "Here's to love, laughter, and happily ever after! Congratulations on your wedding!",
    "May your marriage be blessed with love, joy, and companionship for all your years together!",
    "Wishing you a beautiful wedding day and a lifetime of cherished moments!",
    "Congratulations on your special day! May your love grow stronger with each passing year.",
    "Two hearts, one love, endless happiness. Congratulations, {recipient}!",
    "May your wedding day be just the beginning of a lifetime of love and happiness!",
    "Wishing you both a wonderful journey as you build your new lives together!",
    "Congratulations! May your marriage be filled with all the right ingredients: love, laughter, and happiness!",
    "Here's to love, laughter, and a happily ever after that never ends!",
    "May today be the start of a long and happy life together. Congratulations!",
    "Wishing you joy, love, and happiness on your wedding day and beyond!",
    "Congratulations on finding each other! May your love shine brighter with each year.",
    "May your marriage be blessed with love that grows deeper every day!",
    "Wishing you a lifetime of love, understanding, and companionship. Congratulations, {recipient}!",
    "Two souls, one heart, forever together. Congratulations on your wedding!",
    "May your love story be as magical as your wedding day!",
    "Congratulations! May your journey together be filled with endless love and joy.",
    "Wishing you both a beautiful beginning to your forever!",
    "May your marriage be filled with love, laughter, and countless happy memories!",
    "Congratulations on your wedding! May your love be modern enough to survive the times and old-fashioned enough to last forever.",
    "Wishing you a wonderful life together filled with special moments and treasured memories!",
    "May the love you share today grow stronger as you grow old together. Congratulations!",
    "Here's to a lifetime of adventures, love, and happiness together, {recipient}!",
    "Congratulations! May your marriage be everything you've dreamed of and more.",
    "Wishing you both endless love and happiness on this special day and always!",
    "May your love be the flame that lights your way through life. Congratulations!",
    "Congratulations on your wedding day! May your love story inspire others.",
    "Wishing you a marriage filled with love, joy, and beautiful moments!",
    "May today mark the beginning of your greatest adventure together!",
    "Congratulations! May your love continue to blossom with each passing day.",
    "Wishing you both a lifetime of love, laughter, and happily ever after, {recipient}!",
    "May your marriage be blessed with patience, kindness, and eternal love!",
    "Congratulations on your wedding! May your journey together be extraordinary.",
    "Wishing you a love that grows sweeter with each year that passes!",
    "May your marriage be filled with wonderful moments and cherished memories!",
    "Congratulations! Here's to the beginning of forever together.",
    "Wishing you both a lifetime of shared dreams and beautiful moments!",
    "May your love story be filled with endless chapters of joy and happiness!",
    "Congratulations on finding your perfect match! Wishing you eternal love, {recipient}!",
    "May your wedding day be the start of a lifetime of precious memories!",
    "Wishing you both a marriage full of love, laughter, and beautiful adventures!",
    "Congratulations! May your love shine as bright as it does today, forever.",
    "May your hearts always beat as one. Congratulations on your wedding!",
    "Wishing you a lifetime of happiness and unconditional love together!",
    "Congratulations on your special day! May your love grow deeper with time.",
    "May your marriage be everything you've hoped for and more. Congratulations!",
    "Wishing you both endless joy as you begin this beautiful journey together, {recipient}!"
  ],
  engagement: [
    "Congratulations on your engagement! Wishing you a lifetime of love and happiness, {recipient}!",
    "So happy for you both! May your journey to the altar be filled with joy and excitement!",
    "Congratulations! Your love story is just getting started, and it's already beautiful!",
    "Wishing you both endless happiness as you plan your future together!",
    "Congratulations on finding your forever person! So excited for you!",
    "May your engagement be the beginning of a wonderful adventure together!",
    "So thrilled to hear the news! Congratulations on your engagement, {recipient}!",
    "Wishing you joy and happiness as you prepare for your special day!",
    "Congratulations! Your love is an inspiration to us all.",
    "So happy you found each other! Wishing you a beautiful journey ahead!",
    "Congratulations on your engagement! May your love continue to grow stronger!",
    "Wishing you both all the happiness in the world as you plan your wedding!",
    "So excited for this next chapter in your love story! Congratulations!",
    "May your engagement be filled with love, laughter, and wonderful memories!",
    "Congratulations! Can't wait to celebrate your love, {recipient}!",
    "Wishing you both a lifetime of love and beautiful moments together!",
    "So happy for you! May your engagement be as special as your love!",
    "Congratulations on saying yes! Wishing you endless happiness together!",
    "Your love story is beautiful, and it's only getting better! Congratulations!",
    "Wishing you joy and excitement as you plan your future together!",
    "Congratulations on your engagement! May your love shine forever, {recipient}!",
    "So thrilled for you both! Wishing you a wonderful journey to the altar!",
    "May your engagement be filled with sweet moments and happy memories!",
    "Congratulations! Your forever starts now, and it's going to be amazing!",
    "Wishing you both love, laughter, and happily ever after!",
    "So happy you found your perfect match! Congratulations on your engagement!",
    "May this be the beginning of your most beautiful adventure together!",
    "Congratulations! Wishing you endless love and happiness, {recipient}!",
    "So excited for your future together! Congratulations on your engagement!",
    "May your engagement be as magical as your love story!",
    "Congratulations! Can't wait to see what the future holds for you both!",
    "Wishing you both a lifetime of love, joy, and beautiful memories!",
    "So happy for you! May your engagement be filled with excitement and joy!",
    "Congratulations on finding your forever! Wishing you all the best!",
    "May your love continue to grow as you plan your special day, {recipient}!",
    "So thrilled for you both! Congratulations on your engagement!",
    "Wishing you a beautiful journey as you prepare to say 'I do'!",
    "Congratulations! Your love is truly special and inspiring!",
    "So happy you're taking this next step together! Congratulations!",
    "May your engagement be the start of something wonderful!",
    "Congratulations! Wishing you both endless happiness and love, {recipient}!",
    "So excited to see your love story unfold! Congratulations on your engagement!",
    "May this special time be filled with joy, love, and anticipation!",
    "Congratulations! Your future together looks so bright and beautiful!",
    "Wishing you both all the love and happiness in the world!",
    "So happy for you! May your engagement be everything you've dreamed of!",
    "Congratulations on your engagement! Here's to your forever together!",
    "May your journey to the altar be as beautiful as your love story!",
    "So thrilled for you both! Wishing you a lifetime of love and laughter!",
    "Congratulations! Your engagement is just the beginning of forever, {recipient}!"
  ],
  baby_shower: [
    "Congratulations on your upcoming arrival! Wishing you joy and excitement, {recipient}!",
    "So happy for you! May your baby shower be filled with love and laughter!",
    "Congratulations! A beautiful new chapter is about to begin!",
    "Wishing you all the best as you prepare to welcome your little one!",
    "So excited for you! May your baby bring endless joy and love!",
    "Congratulations on your growing family! Wishing you a wonderful baby shower!",
    "May your baby shower be as special as the little one you're expecting, {recipient}!",
    "So thrilled for you! Wishing you happiness and sweet baby cuddles soon!",
    "Congratulations! Your family is about to get even more amazing!",
    "Wishing you joy and anticipation as you await your precious baby!",
    "So happy for you! May your baby bring you endless smiles and love!",
    "Congratulations on this exciting time! Enjoy every moment, {recipient}!",
    "Wishing you a beautiful baby shower filled with love and celebration!",
    "So excited to celebrate your little one! Congratulations!",
    "May your baby bring you more joy than you ever imagined!",
    "Congratulations! Your life is about to become even more blessed!",
    "Wishing you all the happiness as you prepare for your new arrival!",
    "So happy for you! May your baby shower be magical and memorable!",
    "Congratulations on your bundle of joy arriving soon, {recipient}!",
    "Wishing you sweet moments and beautiful memories with your little one!",
    "So thrilled for you! May parenthood bring you endless joy!",
    "Congratulations! Your baby is already so loved!",
    "Wishing you a wonderful baby shower and a smooth delivery!",
    "So excited for this new adventure! Congratulations!",
    "May your baby bring sunshine and smiles to your every day!",
    "Congratulations! Wishing you all the best for your growing family, {recipient}!",
    "So happy to celebrate this special time with you!",
    "Wishing you joy, love, and lots of baby giggles!",
    "Congratulations on your upcoming arrival! So excited for you!",
    "May your baby shower be filled with love, laughter, and happy tears!",
    "So thrilled for you! Your little one is lucky to have you!",
    "Congratulations! Wishing you a beautiful journey into parenthood!",
    "May your baby bring you more happiness than you ever dreamed possible!",
    "So happy for you! Enjoy every precious moment, {recipient}!",
    "Congratulations! Your family is about to become complete!",
    "Wishing you strength, joy, and all the baby snuggles!",
    "So excited to meet your little one! Congratulations!",
    "May your baby shower be a beautiful celebration of new life!",
    "Congratulations! Your heart is about to expand in ways you never knew possible!",
    "Wishing you all the love and happiness as you await your baby!",
    "So happy for you! May parenthood exceed all your expectations!",
    "Congratulations! Your little miracle will be here before you know it, {recipient}!",
    "Wishing you a wonderful baby shower and a healthy baby!",
    "So thrilled for you! May your baby bring endless joy and love!",
    "Congratulations! Your life is about to change in the most beautiful way!",
    "Wishing you sweet baby moments and precious memories!",
    "So excited for your journey into parenthood! Congratulations!",
    "May your baby be healthy, happy, and loved beyond measure!",
    "Congratulations! Wishing you all the best for your new arrival!",
    "So happy to celebrate this special time with you, {recipient}!"
  ],
  new_baby: [
    "Congratulations on your beautiful new baby! Wishing you endless joy, {recipient}!",
    "Welcome to the world, little one! So happy for your growing family!",
    "Congratulations! Your baby is absolutely precious!",
    "So thrilled for you! May your days be filled with baby smiles and cuddles!",
    "Congratulations on your new arrival! Wishing you love and happiness!",
    "Welcome, sweet baby! May your life be filled with love and laughter!",
    "So happy for you! Congratulations on your beautiful bundle of joy, {recipient}!",
    "Congratulations! Your baby is perfect in every way!",
    "Wishing you wonderful moments and precious memories with your new baby!",
    "So excited to meet your little one! Congratulations on your new arrival!",
    "May your baby bring you more joy than you ever imagined! Congratulations!",
    "Welcome to parenthood! Wishing you love, laughter, and lots of sleep!",
    "Congratulations on your precious new baby! So happy for you!",
    "Your family just got even more beautiful! Congratulations, {recipient}!",
    "So thrilled for you! May your baby bring endless smiles and happiness!",
    "Congratulations! Your little one is so lucky to have you!",
    "Wishing you all the best as you begin this amazing journey with your baby!",
    "So happy for you! May your days be filled with baby giggles and love!",
    "Congratulations on your new arrival! Your baby is absolutely adorable!",
    "Welcome, little one! Wishing your family all the happiness in the world!",
    "So excited for you! Congratulations on your beautiful baby, {recipient}!",
    "May your baby bring you countless moments of pure joy! Congratulations!",
    "Congratulations! Your little miracle is finally here!",
    "Wishing you sweet baby cuddles and beautiful memories!",
    "So happy for your growing family! Congratulations on your new baby!",
    "Your baby is perfect! Congratulations on your new arrival!",
    "May parenthood bring you more love than you ever thought possible!",
    "So thrilled for you! Wishing you all the best with your new baby, {recipient}!",
    "Congratulations! Your baby is a true blessing!",
    "Wishing you precious moments and endless love with your little one!",
    "So happy to celebrate your new arrival! Congratulations!",
    "May your baby grow up healthy, happy, and loved! Congratulations!",
    "Your family is complete! So happy for you, {recipient}!",
    "Congratulations on your beautiful baby! May your hearts overflow with love!",
    "So excited for you! Wishing you wonderful days ahead with your little one!",
    "Welcome to the world, sweet baby! Congratulations to the proud parents!",
    "May your baby bring sunshine to your every day! Congratulations!",
    "So thrilled for you! Your baby is absolutely precious, {recipient}!",
    "Congratulations! Wishing you all the love and happiness with your new arrival!",
    "Your little one is here! So happy for you and your growing family!",
    "May your baby fill your home with laughter and love! Congratulations!",
    "So happy for you! Wishing you beautiful moments with your new baby!",
    "Congratulations on your perfect little miracle, {recipient}!",
    "Your baby is adorable! Wishing you all the best in this new chapter!",
    "So excited to meet your little one! Congratulations on your new arrival!",
    "May your baby bring you endless joy and precious memories! Congratulations!",
    "Congratulations! Your family just became even more blessed!",
    "So happy for you! May your baby bring you more love than you ever imagined!",
    "Welcome, beautiful baby! Wishing your family all the happiness in the world!",
    "Congratulations on your new bundle of joy! So thrilled for you, {recipient}!"
  ],
  graduation: [
    "Congratulations on your graduation! You did it, {recipient}!",
    "So proud of you! Your hard work has paid off. Congratulations, graduate!",
    "Congratulations! This is just the beginning of your amazing journey!",
    "You did it! Wishing you continued success in all your future endeavors!",
    "Congratulations on this incredible achievement! The world is yours!",
    "So happy for you! Your graduation is well-deserved. Congratulations!",
    "You've worked so hard for this moment. Congratulations, {recipient}!",
    "Congratulations on your graduation! May your future be bright and full of possibilities!",
    "So proud of your accomplishment! Congratulations, graduate!",
    "You did it! Wishing you all the best as you start your next chapter!",
    "Congratulations! Your dedication has brought you to this amazing milestone!",
    "So excited for your future! Congratulations on your graduation, {recipient}!",
    "You've earned this moment! Congratulations on your graduation!",
    "Congratulations! May this be the first of many great achievements!",
    "So happy to celebrate this special day with you! Congratulations, graduate!",
    "You did it! Your future is full of endless possibilities. Congratulations!",
    "Congratulations on reaching this important milestone, {recipient}!",
    "So proud of you! May your graduation be the start of something wonderful!",
    "You've worked incredibly hard for this. Congratulations on your graduation!",
    "Congratulations! Your achievement inspires us all!",
    "So excited for what's next! Congratulations, graduate!",
    "You did it! Wishing you success and happiness in all you do, {recipient}!",
    "Congratulations on your graduation! Your future is so bright!",
    "So happy for you! May this accomplishment open many doors!",
    "You've made it! Congratulations on this well-deserved success!",
    "Congratulations! Your hard work and determination have paid off beautifully!",
    "So proud of you! Wishing you all the best in your next adventure, {recipient}!",
    "You did it! May your graduation be the beginning of great things!",
    "Congratulations on this amazing achievement! The best is yet to come!",
    "So excited for your future! Congratulations, graduate!",
    "You've earned every bit of this success. Congratulations on your graduation!",
    "Congratulations! May your diploma be the key to your dreams, {recipient}!",
    "So happy to celebrate this milestone with you! Congratulations!",
    "You did it! Your perseverance has led to this wonderful moment!",
    "Congratulations on your graduation! Wishing you continued success!",
    "So proud of how far you've come! Congratulations, {recipient}!",
    "You've achieved something truly special. Congratulations, graduate!",
    "Congratulations! May your future be filled with endless opportunities!",
    "So excited for you! Your graduation is just the beginning!",
    "You did it! Wishing you happiness and success in all your endeavors!",
    "Congratulations on reaching this incredible milestone, {recipient}!",
    "So happy for you! May your education take you far!",
    "You've worked so hard for this day. Congratulations on your graduation!",
    "Congratulations! Your achievement is an inspiration to us all!",
    "So proud of you! May your future be as bright as your smile today!",
    "You did it! Congratulations on this well-earned success, {recipient}!",
    "Congratulations on your graduation! The world needs your talents!",
    "So excited for what you'll accomplish next! Congratulations, graduate!",
    "You've proven that hard work pays off. Congratulations on your graduation!",
    "Congratulations! Wishing you all the best as you embark on your next journey!"
  ],
  retirement: [
    "Happy Retirement! Wishing you relaxation, adventure, and endless joy, {recipient}!",
    "Congratulations on your retirement! You've earned every moment of this!",
    "So happy for you! May your retirement be filled with everything you love!",
    "Happy Retirement! Time to enjoy the fruits of your labor!",
    "Congratulations! Wishing you a retirement full of happiness and new adventures!",
    "So excited for you! May your retirement be everything you've dreamed of, {recipient}!",
    "Happy Retirement! Thank you for your years of dedication and hard work!",
    "Congratulations on reaching this wonderful milestone! Enjoy every moment!",
    "So happy for you! May your retirement be filled with joy and relaxation!",
    "Happy Retirement! Time to do all the things you've been waiting for!",
    "Congratulations! Wishing you health, happiness, and endless free time!",
    "So thrilled for you! May your retirement be the best chapter yet, {recipient}!",
    "Happy Retirement! You've worked hard, now it's time to play hard!",
    "Congratulations! May your retirement days be filled with peace and contentment!",
    "So happy for you! Wishing you a retirement full of love and laughter!",
    "Happy Retirement! Thank you for all you've contributed over the years!",
    "Congratulations! May this new chapter bring you joy and fulfillment!",
    "So excited for you! Your retirement is well-deserved, {recipient}!",
    "Happy Retirement! Time to enjoy life at your own pace!",
    "Congratulations! Wishing you wonderful adventures in your retirement!",
    "So happy for you! May every day of retirement be a blessing!",
    "Happy Retirement! You've earned the right to relax and enjoy!",
    "Congratulations! May your retirement be filled with precious moments!",
    "So thrilled for you! Wishing you health and happiness always, {recipient}!",
    "Happy Retirement! Time to pursue all your passions and hobbies!",
    "Congratulations! Your legacy of hard work will always be remembered!",
    "So happy for you! May your retirement exceed all expectations!",
    "Happy Retirement! Wishing you days filled with sunshine and smiles!",
    "Congratulations! You've worked hard, now enjoy the freedom!",
    "So excited for you! May your retirement be everything you've hoped for, {recipient}!",
    "Happy Retirement! Time to make new memories and enjoy life!",
    "Congratulations! Wishing you a retirement full of joy and adventure!",
    "So happy for you! May this new phase bring you peace and happiness!",
    "Happy Retirement! You deserve all the relaxation and fun ahead!",
    "Congratulations! May your retirement days be golden and bright!",
    "So thrilled for you! Wishing you endless happiness in retirement, {recipient}!",
    "Happy Retirement! Time to enjoy the simple pleasures of life!",
    "Congratulations! Your retirement is the beginning of a beautiful journey!",
    "So happy for you! May every day be a Saturday now!",
    "Happy Retirement! Wishing you health, happiness, and fulfillment!",
    "Congratulations! May your retirement be filled with love and laughter!",
    "So excited for you! Time to enjoy life without deadlines, {recipient}!",
    "Happy Retirement! You've earned every moment of this new chapter!",
    "Congratulations! Wishing you a retirement full of beautiful moments!",
    "So happy for you! May your retirement be everything you deserve!",
    "Happy Retirement! Time to relax, travel, and enjoy!",
    "Congratulations! Your hard work has led to this wonderful milestone!",
    "So thrilled for you! May your retirement bring you joy every day!",
    "Happy Retirement! Wishing you endless days of peace and contentment!",
    "Congratulations! May this next chapter be your best one yet, {recipient}!"
  ],
  housewarming: [
    "Congratulations on your new home! Wishing you happiness and wonderful memories, {recipient}!",
    "So happy for you! May your new house be filled with love and laughter!",
    "Congratulations! Wishing you all the best in your beautiful new home!",
    "So excited for you! May your home be a place of comfort and joy!",
    "Congratulations on your new nest! Wishing you warmth and happiness!",
    "So happy for you! May your new home be filled with love and laughter, {recipient}!",
    "Congratulations! Wishing you countless happy memories in your new home!",
    "So thrilled for you! May your house become a beautiful home!",
    "Congratulations on this exciting new chapter! Enjoy your new space!",
    "So happy for you! May your home be blessed with love and joy!",
    "Congratulations! Wishing you comfort and happiness in your new home, {recipient}!",
    "So excited for you! May your new house be filled with wonderful moments!",
    "Congratulations on your new place! Wishing you all the best!",
    "So happy for you! May your home be a sanctuary of peace and love!",
    "Congratulations! May your new home bring you endless happiness!",
    "So thrilled for you! Wishing you beautiful memories in your new space, {recipient}!",
    "Congratulations on your new home! May it be filled with laughter and love!",
    "So happy for you! Wishing you warmth and joy in every room!",
    "Congratulations! May your new home be everything you've dreamed of!",
    "So excited for you! Wishing you happiness and comfort in your new place!",
    "Congratulations on your new address! May it be a place of love and joy, {recipient}!",
    "So happy for you! May your home be blessed with wonderful memories!",
    "Congratulations! Wishing you peace and happiness in your new home!",
    "So thrilled for you! May your house be filled with love and laughter!",
    "Congratulations on your new beginning! Enjoy making it your own!",
    "So happy for you! May your home be a haven of happiness, {recipient}!",
    "Congratulations! Wishing you countless happy moments in your new space!",
    "So excited for you! May your new home bring you joy every day!",
    "Congratulations on your new home! May it be filled with love and laughter!",
    "So happy for you! Wishing you comfort and joy in your new place!",
    "Congratulations! May your home be blessed with warmth and happiness!",
    "So thrilled for you! Wishing you beautiful memories ahead, {recipient}!",
    "Congratulations on your new home! May it be your perfect sanctuary!",
    "So happy for you! May your house be filled with love and laughter!",
    "Congratulations! Wishing you endless happiness in your new space!",
    "So excited for you! May your home be everything you've hoped for!",
    "Congratulations on your new address! Wishing you joy and comfort, {recipient}!",
    "So happy for you! May your home be a place of peace and love!",
    "Congratulations! Wishing you wonderful times in your beautiful new home!",
    "So thrilled for you! May your house become a home filled with memories!",
    "Congratulations on your new place! Wishing you happiness and warmth!",
    "So happy for you! May your home be blessed with love and joy!",
    "Congratulations! May your new home bring you comfort and happiness, {recipient}!",
    "So excited for you! Wishing you beautiful moments in your new space!",
    "Congratulations on your new home! May it be filled with laughter and love!",
    "So happy for you! Wishing you peace and contentment in your new place!",
    "Congratulations! May your home be a source of joy and comfort!",
    "So thrilled for you! Wishing you all the best in your new home!",
    "Congratulations on your new beginning! May it be everything you've dreamed of!",
    "So happy for you! May your new home be filled with endless happiness, {recipient}!"
  ],
  memorial: [
    "In loving memory of a beautiful soul. May their light continue to shine through you, {recipient}.",
    "Remembering someone special today and always. Sending you love and comfort.",
    "Their memory lives on in the hearts of all who loved them. Thinking of you.",
    "In remembrance of a life beautifully lived and a heart deeply loved.",
    "May the memories you shared bring you comfort during this difficult time.",
    "Celebrating a life that touched so many hearts. Forever remembered, {recipient}.",
    "In loving memory. May you find peace in the beautiful moments you shared.",
    "Their spirit lives on through the love they gave and the memories they created.",
    "Remembering someone truly special. May their memory be a blessing.",
    "In honor of a life well-lived and deeply cherished. Thinking of you.",
    "May the love and memories you shared bring you comfort and peace.",
    "Remembering with love someone who made the world a better place.",
    "Their legacy of love will live on forever. Sending you strength, {recipient}.",
    "In loving memory of someone who will never be forgotten.",
    "May cherished memories bring you comfort in this time of loss.",
    "Remembering a beautiful soul whose kindness touched so many lives.",
    "In memory of someone who brought so much joy to the world.",
    "Their love and light will continue to guide you. Thinking of you.",
    "Celebrating a life filled with love, laughter, and beautiful memories.",
    "May the memories of happier times bring you peace and comfort, {recipient}.",
    "In loving remembrance. Their spirit lives on in all who loved them.",
    "Honoring a life that was a gift to everyone who knew them.",
    "May you find solace in the beautiful memories you created together.",
    "Remembering someone whose love made a lasting impact on so many.",
    "Their memory will forever be a treasure in your heart.",
    "In loving memory. May their legacy of kindness live on forever, {recipient}.",
    "Celebrating a life that brought so much love and joy to others.",
    "May the love they gave return to comfort you now.",
    "Remembering someone special whose memory will never fade.",
    "Their spirit remains with you in every cherished memory.",
    "In honor of a beautiful soul who touched so many lives.",
    "May you find comfort in knowing they were deeply loved, {recipient}.",
    "Remembering with love and celebrating a life well-lived.",
    "Their kindness and love will be remembered always.",
    "In memory of someone who made every moment count.",
    "May precious memories bring you peace during this difficult time.",
    "Celebrating a life filled with love, compassion, and grace.",
    "Their legacy of love continues through all who knew them, {recipient}.",
    "Remembering someone whose light will never dim.",
    "In loving memory. May you find strength in the love you shared.",
    "Honoring a life that was a blessing to so many.",
    "May the memories you hold dear bring you comfort always.",
    "Remembering someone truly special who will live on in our hearts.",
    "Their love story continues through the memories they left behind.",
    "In memory of a beautiful soul who made the world brighter, {recipient}.",
    "May you find peace in knowing they were loved beyond measure.",
    "Celebrating a life that inspired and touched so many.",
    "Their memory is a treasure that will last forever.",
    "Remembering with love someone who gave so much to others.",
    "May their spirit bring you comfort and their memory bring you peace, {recipient}."
  ],
  pet: [
    "Celebrating your furry friend today! Wishing you both joy and happiness, {recipient}!",
    "Happy Birthday to your precious pet! May their day be filled with treats and love!",
    "So happy to celebrate your beloved companion! They bring so much joy!",
    "Wishing your pet a day full of belly rubs, treats, and playtime!",
    "Happy Birthday to the cutest pet ever! Celebrating your furry family member!",
    "Your pet is so lucky to have you! Wishing them endless tail wags and purrs, {recipient}!",
    "Celebrating the unconditional love your pet brings every day!",
    "Happy Birthday to your four-legged friend! May their day be pawfect!",
    "So happy to honor your special companion! They deserve all the love!",
    "Wishing your pet a day filled with their favorite things!",
    "Happy Birthday to your amazing pet! They make life so much better, {recipient}!",
    "Celebrating the joy and laughter your pet brings to your life!",
    "Your furry friend deserves all the love today and always!",
    "Happy Birthday to your precious companion! May their day be magical!",
    "So happy to celebrate the bond you share with your pet!",
    "Wishing your pet endless treats, toys, and love today, {recipient}!",
    "Happy Birthday to your loyal friend! They're truly one of a kind!",
    "Celebrating the happiness your pet brings to everyone around them!",
    "Your pet is so special! Wishing them the best day ever!",
    "Happy Birthday to your furry family member! May their day be wonderful!",
    "So happy to honor your beloved pet today, {recipient}!",
    "Wishing your companion a day full of their favorite activities!",
    "Happy Birthday to the sweetest pet! They deserve all the cuddles!",
    "Celebrating the unconditional love and joy your pet provides!",
    "Your pet makes the world a better place! Happy Birthday to them!",
    "So happy to celebrate your four-legged friend today, {recipient}!",
    "Wishing your pet endless happiness and belly scratches!",
    "Happy Birthday to your amazing companion! They're truly family!",
    "Celebrating the special bond between you and your pet!",
    "Your furry friend brings so much joy! Wishing them the best!",
    "Happy Birthday to your precious pet! May their day be filled with love, {recipient}!",
    "So happy to honor the love and loyalty your pet shows every day!",
    "Wishing your pet a day as special as they are to you!",
    "Happy Birthday to your wonderful companion! They're truly a blessing!",
    "Celebrating the happiness and comfort your pet brings!",
    "Your pet is family! Wishing them the happiest of birthdays, {recipient}!",
    "So happy to celebrate your furry friend's special day!",
    "Wishing your pet endless love, treats, and playtime!",
    "Happy Birthday to your loyal companion! They make life complete!",
    "Celebrating the pure joy your pet brings to your life!",
    "Your pet deserves all the love today! Happy Birthday to them, {recipient}!",
    "So happy to honor your beloved friend on their special day!",
    "Wishing your pet a day filled with their favorite things!",
    "Happy Birthday to your amazing pet! They're truly one in a million!",
    "Celebrating the beautiful bond you share with your companion!",
    "Your pet brings so much happiness! Wishing them the best day!",
    "Happy Birthday to your furry family member! May their day be pawsome, {recipient}!",
    "So happy to celebrate the love and joy your pet provides!",
    "Wishing your companion endless cuddles and happy moments!",
    "Happy Birthday to your precious pet! They're truly a gift!"
  ],
  farewell: [
    "Wishing you all the best in your next adventure! We'll miss you, {recipient}!",
    "Good luck on your new journey! Thank you for all the wonderful memories!",
    "Farewell and best wishes! May your future be bright and successful!",
    "We'll miss you! Wishing you happiness and success in your next chapter!",
    "Thank you for everything! Best of luck in all you do, {recipient}!",
    "Farewell! May your new path bring you joy and fulfillment!",
    "Wishing you success and happiness as you move forward! We'll miss you!",
    "Good luck with your new adventure! Thank you for being amazing!",
    "Farewell! May your future be filled with exciting opportunities, {recipient}!",
    "We'll miss your presence! Wishing you all the best ahead!",
    "Thank you for the memories! Best wishes for your next chapter!",
    "Farewell and good luck! May your journey be everything you hope for!",
    "Wishing you success in all your future endeavors! We'll miss you!",
    "Good luck! Thank you for all you've contributed, {recipient}!",
    "Farewell! May your new beginning exceed all expectations!",
    "We'll miss you! Wishing you happiness and success always!",
    "Thank you for everything! Best of luck on your new path!",
    "Farewell! May your future be as bright as your smile, {recipient}!",
    "Wishing you all the best! You'll be greatly missed!",
    "Good luck with your next adventure! Thank you for the memories!",
    "Farewell! May your journey be filled with joy and success!",
    "We'll miss you! Wishing you wonderful things ahead, {recipient}!",
    "Thank you for your contributions! Best wishes for the future!",
    "Farewell and good luck! May your new chapter be amazing!",
    "Wishing you success and happiness! You'll always be remembered!",
    "Good luck! Thank you for making such a positive impact, {recipient}!",
    "Farewell! May your future be filled with exciting possibilities!",
    "We'll miss you! Wishing you all the best in your next role!",
    "Thank you for everything! Best wishes for your new journey!",
    "Farewell! May your path ahead be bright and rewarding, {recipient}!",
    "Wishing you success! You've been an amazing colleague!",
    "Good luck with your new adventure! We'll miss you greatly!",
    "Farewell! May your future bring you happiness and fulfillment!",
    "We'll miss you! Thank you for all the wonderful times, {recipient}!",
    "Wishing you the very best! Good luck in all you do!",
    "Farewell and best wishes! May your journey be successful!",
    "Thank you for your dedication! Wishing you happiness ahead!",
    "Good luck! You'll be missed more than you know, {recipient}!",
    "Farewell! May your new chapter be everything you've dreamed of!",
    "We'll miss you! Wishing you success and joy in your future!",
    "Thank you for being wonderful! Best wishes for what's next!",
    "Farewell! May your journey bring you endless opportunities, {recipient}!",
    "Wishing you all the best! You've been truly appreciated!",
    "Good luck on your new path! We'll miss you!",
    "Farewell! May your future be bright and fulfilling!",
    "We'll miss you! Thank you for all you've done, {recipient}!",
    "Wishing you success and happiness! Good luck ahead!",
    "Farewell! May your new adventure be everything you hope for!",
    "Thank you for the memories! Best wishes for your future!",
    "Good luck! You'll be missed, but we're excited for you, {recipient}!"
  ],
  custom: [
    "Thinking of you and sending love your way, {recipient}!",
    "You're in my thoughts today and always!",
    "Just wanted to remind you how special you are!",
    "Sending you positive vibes and warm wishes!",
    "Hope this brings a smile to your face!",
    "You deserve all the wonderful things coming your way!",
    "Thinking of you and wishing you happiness!",
    "You're amazing, and I wanted you to know it!",
    "Sending love and good energy your way, {recipient}!",
    "Hope your day is as wonderful as you are!",
    "You make the world a better place!",
    "Just a little something to brighten your day!",
    "You're one of a kind, and that's beautiful!",
    "Wishing you joy in every moment!",
    "You're loved more than you know!",
    "Hope this reminds you how much you mean to me!",
    "Sending sunshine and smiles your way!",
    "You deserve all the happiness in the world, {recipient}!",
    "Just because you're awesome!",
    "Thinking of you and sending warm thoughts!",
    "You light up every room you enter!",
    "Here's a little reminder of how wonderful you are!",
    "May your day be filled with pleasant surprises!",
    "You're appreciated more than words can express!",
    "Sending you love and positivity today!",
    "You're a blessing in so many ways!",
    "Hope this makes you smile as much as you make me smile!",
    "You're incredible, never forget that!",
    "Wishing you all the best today and always!",
    "You're the reason for so many smiles, {recipient}!",
    "Just wanted to let you know you're thought of!",
    "You make life more beautiful!",
    "Sending you a virtual hug and lots of love!",
    "You're cherished more than you realize!",
    "May your day be as special as you are!",
    "You're a true gem!",
    "Hope this brightens your day like you brighten mine!",
    "You're wonderful in every way!",
    "Sending good vibes your way today, {recipient}!",
    "You deserve recognition for being so amazing!",
    "You're loved, appreciated, and valued!",
    "Hope you know how special you truly are!",
    "You make everything better!",
    "Wishing you happiness in abundance!",
    "You're a beautiful person inside and out!",
    "Just a reminder that you're awesome!",
    "May your day be filled with joy and laughter!",
    "You're someone truly special, {recipient}!",
    "Sending love and appreciation your way!",
    "You make the world brighter just by being you!"
  ]
};

const GiftCardPurchaseModal = ({ isOpen, onClose, user, selectedPackage, productType = 'credits' }) => {
  const { t } = useTranslation();
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    design_template: 'birthday',
    occasion: 'birthday',
    recipient_name: '',
    recipient_email: '',
    personal_message: '',
    sender_name: user?.name || '',
    from_name: user?.name || 'Friend',  // Default to user name or 'Friend'
    holiday_subtype: '',
    custom_greeting: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [giftCardCode, setGiftCardCode] = useState(null);
  const [usedMessageIndices, setUsedMessageIndices] = useState({});

  const designTemplates = [
    {
      id: 'birthday',
      name: t('gift_card.occasions.birthday'),
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 15.546c-.523 0-1.046.151-1.5.454a2.704 2.704 0 01-3 0 2.704 2.704 0 00-3 0 2.704 2.704 0 01-3 0 2.704 2.704 0 00-3 0 2.704 2.704 0 01-3 0 2.546 2.546 0 00-1.5-.454M9 6v2m3-2v2m3-2v2M9 3h.01M12 3h.01M15 3h.01M21 21v-7a2 2 0 00-2-2H5a2 2 0 00-2 2v7h18zm-3-9v-2a2 2 0 00-2-2H8a2 2 0 00-2 2v2h12z" />
        </svg>
      ),
      color: 'from-pink-500 to-purple-500',
      bgColor: 'bg-gradient-to-br from-pink-50 to-purple-50',
    },
    {
      id: 'holiday',
      name: t('gift_card.occasions.holiday'),
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
        </svg>
      ),
      color: 'from-red-500 to-green-500',
      bgColor: 'bg-gradient-to-br from-red-50 to-green-50',
      subOptions: [
        { id: 'christmas', name: t('gift_card.occasions.christmas'), greeting: t('gift_card.greetings.christmas') },
        { id: 'hanukkah', name: t('gift_card.occasions.hanukkah'), greeting: t('gift_card.greetings.hanukkah') },
        { id: 'kwanzaa', name: t('gift_card.occasions.kwanzaa'), greeting: t('gift_card.greetings.kwanzaa') },
        { id: 'diwali', name: t('gift_card.occasions.diwali'), greeting: t('gift_card.greetings.diwali') },
        { id: 'eid', name: t('gift_card.occasions.eid'), greeting: t('gift_card.greetings.eid') },
        { id: 'lunar_new_year', name: t('gift_card.occasions.lunar_new_year'), greeting: t('gift_card.greetings.lunar_new_year') },
        { id: 'general_holiday', name: t('gift_card.occasions.general_holiday'), greeting: t('gift_card.greetings.general_holiday') }
      ]
    },
    {
      id: 'anniversary',
      name: t('gift_card.occasions.anniversary'),
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
        </svg>
      ),
      color: 'from-red-500 to-pink-600',
      bgColor: 'bg-gradient-to-br from-red-50 to-pink-50',
    },
    {
      id: 'celebration',
      name: t('gift_card.occasions.celebration'),
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
        </svg>
      ),
      color: 'from-yellow-500 to-orange-600',
      bgColor: 'bg-gradient-to-br from-yellow-50 to-orange-50',
    },
    {
      id: 'thankyou',
      name: t('gift_card.occasions.thankyou'),
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          {/* Thumbs up */}
          <path d="M14 9V5a3 3 0 00-3-3l-4 9v11h11.28a2 2 0 002-1.7l1.38-9a2 2 0 00-2-2.3zM7 22H4a2 2 0 01-2-2v-7a2 2 0 012-2h3v11z"/>
        </svg>
      ),
      color: 'from-blue-500 to-teal-600',
      bgColor: 'bg-gradient-to-br from-blue-50 to-teal-50',
    },
    {
      id: 'mothers_day',
      name: t('gift_card.occasions.mothers_day'),
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          {/* Flower icon */}
          <circle cx="12" cy="10" r="2" fill="currentColor"/>
          <path d="M12 4C10.9 4 10 4.9 10 6C10 6.3 10.1 6.6 10.2 6.9C9.6 6.3 8.8 6 8 6C6.9 6 6 6.9 6 8C6 9.1 6.9 10 8 10C8.8 10 9.6 9.7 10.2 9.1C10.1 9.4 10 9.7 10 10C10 10.3 10.1 10.6 10.2 10.9C9.6 10.3 8.8 10 8 10C6.9 10 6 10.9 6 12C6 13.1 6.9 14 8 14C8.8 14 9.6 13.7 10.2 13.1C10.1 13.4 10 13.7 10 14C10 15.1 10.9 16 12 16C13.1 16 14 15.1 14 14C14 13.7 13.9 13.4 13.8 13.1C14.4 13.7 15.2 14 16 14C17.1 14 18 13.1 18 12C18 10.9 17.1 10 16 10C15.2 10 14.4 10.3 13.8 10.9C13.9 10.6 14 10.3 14 10C14 9.7 13.9 9.4 13.8 9.1C14.4 9.7 15.2 10 16 10C17.1 10 18 9.1 18 8C18 6.9 17.1 6 16 6C15.2 6 14.4 6.3 13.8 6.9C13.9 6.6 14 6.3 14 6C14 4.9 13.1 4 12 4Z"/>
          <path d="M12 16L12 22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
      ),
      color: 'from-pink-400 to-rose-500',
      bgColor: 'bg-gradient-to-br from-pink-50 to-rose-50',
    },
    {
      id: 'fathers_day',
      name: t('gift_card.occasions.fathers_day'),
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          {/* Necktie with collar and knot */}
          <rect x="10" y="2" width="4" height="1.5" rx="0.3"/>
          <path d="M10.5 3.5 L10 4.5 L9.5 6 L9 8 L10 16 L11 20 L12 22 L13 20 L14 16 L15 8 L14.5 6 L14 4.5 L13.5 3.5 Z"/>
          <path d="M10.5 4 L11.5 3.5 L12.5 3.5 L13.5 4 L13 5 L12 6 L11 5 Z" opacity="0.4"/>
        </svg>
      ),
      color: 'from-blue-500 to-indigo-600',
      bgColor: 'bg-gradient-to-br from-blue-50 to-indigo-50',
    },
    {
      id: 'wedding',
      name: t('gift_card.occasions.wedding'),
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          {/* Wedding rings */}
          <circle cx="8" cy="12" r="5" fill="none" stroke="currentColor" strokeWidth="1.5"/>
          <circle cx="16" cy="12" r="5" fill="none" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M11 12C11 14 10 15 8 15C6 15 5 14 5 12C5 10 6 9 8 9C10 9 11 10 11 12Z" fill="none" stroke="currentColor" strokeWidth="1"/>
          <path d="M19 12C19 14 18 15 16 15C14 15 13 14 13 12C13 10 14 9 16 9C18 9 19 10 19 12Z" fill="none" stroke="currentColor" strokeWidth="1"/>
        </svg>
      ),
      color: 'from-rose-400 to-pink-500',
      bgColor: 'bg-gradient-to-br from-rose-50 to-pink-50',
    },
    {
      id: 'engagement',
      name: t('gift_card.occasions.engagement'),
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          {/* Diamond ring */}
          <circle cx="12" cy="15" r="6" fill="none" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M9 6L12 3L15 6L13 9L12 10L11 9L9 6Z" fill="currentColor"/>
          <path d="M12 10L12 12" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
      ),
      color: 'from-purple-400 to-pink-500',
      bgColor: 'bg-gradient-to-br from-purple-50 to-pink-50',
    },
    {
      id: 'baby_shower',
      name: t('gift_card.occasions.baby_shower'),
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          {/* Gift box with bow */}
          <rect x="6" y="10" width="12" height="10" fill="none" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M6 10L18 10L18 12L6 12Z" fill="currentColor"/>
          <path d="M12 4C10.5 4 10 5 10 6L10 10L14 10L14 6C14 5 13.5 4 12 4Z" fill="currentColor"/>
          <circle cx="10" cy="6" r="1.5" fill="currentColor"/>
          <circle cx="14" cy="6" r="1.5" fill="currentColor"/>
          <line x1="12" y1="10" x2="12" y2="20" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
      ),
      color: 'from-cyan-400 to-blue-400',
      bgColor: 'bg-gradient-to-br from-cyan-50 to-blue-50',
    },
    {
      id: 'new_baby',
      name: t('gift_card.occasions.new_baby'),
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      color: 'from-yellow-400 to-amber-400',
      bgColor: 'bg-gradient-to-br from-yellow-50 to-amber-50',
    },
    {
      id: 'graduation',
      name: t('gift_card.occasions.graduation'),
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path d="M12 14l9-5-9-5-9 5 9 5z" />
          <path d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222" />
        </svg>
      ),
      color: 'from-emerald-500 to-teal-600',
      bgColor: 'bg-gradient-to-br from-emerald-50 to-teal-50',
    },
    {
      id: 'retirement',
      name: t('gift_card.occasions.retirement'),
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
      ),
      color: 'from-amber-500 to-orange-600',
      bgColor: 'bg-gradient-to-br from-amber-50 to-orange-50',
    },
    {
      id: 'housewarming',
      name: t('gift_card.occasions.housewarming'),
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
        </svg>
      ),
      color: 'from-green-500 to-emerald-600',
      bgColor: 'bg-gradient-to-br from-green-50 to-emerald-50',
    },
    {
      id: 'memorial',
      name: 'In Remembrance',
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          {/* Candle with flame */}
          <ellipse cx="12" cy="6" rx="2" ry="3" fill="currentColor" opacity="0.6"/>
          <path d="M12 4C11.5 4 11 5 11 6C11 7 11.5 8 12 8C12.5 8 13 7 13 6C13 5 12.5 4 12 4Z" fill="currentColor"/>
          <rect x="10" y="8" width="4" height="12" rx="0.5" fill="currentColor"/>
          <ellipse cx="12" cy="20" rx="3" ry="1" fill="currentColor" opacity="0.4"/>
          <path d="M9 20L9 21L15 21L15 20" stroke="currentColor" strokeWidth="0.5"/>
        </svg>
      ),
      color: 'from-slate-400 to-gray-500',
      bgColor: 'bg-gradient-to-br from-slate-50 to-gray-50',
    },
    {
      id: 'pet',
      name: 'Pet Celebration',
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          {/* Dog paw print */}
          {/* Main pad */}
          <ellipse cx="12" cy="16" rx="3.5" ry="4" fill="currentColor"/>
          {/* Toe pads - arranged like dog paw */}
          <ellipse cx="7.5" cy="10" rx="1.8" ry="2.5" fill="currentColor"/>
          <ellipse cx="11" cy="8" rx="1.8" ry="2.5" fill="currentColor"/>
          <ellipse cx="14.5" cy="8" rx="1.8" ry="2.5" fill="currentColor"/>
          <ellipse cx="17" cy="10" rx="1.8" ry="2.5" fill="currentColor"/>
        </svg>
      ),
      color: 'from-orange-400 to-red-500',
      bgColor: 'bg-gradient-to-br from-orange-50 to-red-50',
    },
    {
      id: 'farewell',
      name: t('gift_card.occasions.farewell'),
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          {/* Waving hand with palm and fingers */}
          <path d="M8 14C8 12 9 11 10 11C11 11 11 12 11 13L11 17L10 18L8 17L8 14Z"/>
          <path d="M11 13L11 8C11 6 12 5 13 5C14 5 14 6 14 8L14 13"/>
          <path d="M14 13L14 6C14 4.5 15 4 16 4C17 4 17 5 17 6L17 13"/>
          <path d="M17 13L17 8C17 7 18 7 18.5 7.5C19 8 19 9 19 10L19 14C19 16 18 18 16 19C14 20 11 19 10 18L8 17"/>
          {/* Motion lines */}
          <path d="M13 3L13.5 1" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" opacity="0.7"/>
          <path d="M16 3L17 1" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" opacity="0.7"/>
          <path d="M19 5L20.5 3.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" opacity="0.7"/>
        </svg>
      ),
      color: 'from-indigo-500 to-purple-600',
      bgColor: 'bg-gradient-to-br from-indigo-50 to-purple-50',
    },
    {
      id: 'custom',
      name: 'Custom',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01" />
        </svg>
      ),
      color: 'from-purple-500 to-blue-600',
      bgColor: 'bg-gradient-to-br from-purple-50 to-blue-50',
      isCustom: true
    },
  ];

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleInputKeyDown = (e) => {
    // Prevent Enter key from submitting form
    if (e.key === 'Enter') {
      e.preventDefault();
      return false;
    }
  };

  const handleTemplateSelect = (templateId) => {
    setFormData({
      ...formData,
      design_template: templateId,
      occasion: templateId,
      // Reset holiday subtype when changing templates - empty to show picker
      holiday_subtype: '',
      // Reset custom greeting when changing templates
      custom_greeting: templateId === 'custom' ? 'You Received a Gift!' : ''
    });
  };

  const handleNextStep = () => {
    // Only one transition: step 1 to step 2
    if (step === 1) {
      // Occasion selected, go to review & sign
      setStep(2);
    }
  };

  const handleAddToCart = async (e) => {
    // Prevent any default form behavior
    if (e) e.preventDefault();
    
    // Validate recipient name
    if (!formData.recipient_name || !formData.recipient_name.trim()) {
      toast.error('Please enter recipient name');
      return;
    }
    
    // For credits, email is REQUIRED (email-only delivery)
    if (productType === 'credits') {
      if (!formData.recipient_email || !formData.recipient_email.trim()) {
        toast.error('Recipient email is required for credit gifts');
        return;
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.recipient_email.trim())) {
        toast.error('Please enter a valid email address');
        return;
      }
    } else {
      // For frames, validate email if provided
      if (formData.recipient_email && formData.recipient_email.trim()) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData.recipient_email.trim())) {
          toast.error('Please enter a valid email address');
          return;
        }
      }
    }
    
    setIsLoading(true);
    
    try {
      console.log('📦 selectedPackage:', selectedPackage);
      const frameData = selectedPackage?.frame || selectedPackage;
      const moments = selectedPackage?.moments || [];
      console.log('🖼️ frameData:', frameData);
      console.log('🎬 moments:', moments);
      console.log('🎬 moments count:', moments.length);
      console.log('🎬 first moment:', moments[0]);
      
      // Prepare gift data for cart
      // For credits, construct product_id from credits amount
      const productId = productType === 'credits' 
        ? `credit_${selectedPackage.credits}_${selectedPackage.price}` 
        : (frameData.id || frameData.product_id || frameData.productId);
      
      const giftData = {
        product_id: productId,
        variant_id: frameData.variantId || frameData.variant_id || null,
        title: productType === 'credits' 
          ? `${selectedPackage.credits} Credits Gift Card` 
          : (frameData.display || frameData.title),
        price: parseFloat(frameData.price || selectedPackage.price),
        quantity: 1,
        image_url: frameData.featuredImage || frameData.image_url || null,
        recipient_name: formData.recipient_name,
        recipient_email: formData.recipient_email || '',
        gift_message: formData.personal_message || '',
        delivery_date: new Date().toISOString(),
        design_template: formData.design_template,
        occasion: formData.occasion,
        holiday_subtype: formData.holiday_subtype || '',
        custom_greeting: formData.custom_greeting || '',
        selected_media: moments.map(m => ({
          id: m.id,
          type: m.type || 'video',
          thumbnail_url: m.thumbnail_url,
          source_id: m.source_id || m.id
        }))
      };
      
      console.log('🎁 Adding gift to cart:', giftData);
      
      // Get session token for authentication
      const sessionToken = localStorage.getItem('session_token');
      
      const response = await axios.post(
        `${getAPI()}/shop/cart/add-gift?user_id=${user.id}`,
        giftData,
        {
          headers: {
            'Authorization': `Bearer ${sessionToken}`
          }
        }
      );
      
      console.log('✅ Gift added to cart successfully:', response.data);
      
      if (response.data.success) {
        // For "Add to Cart" button, just add to cart and show success (don't auto-proceed to checkout)
        toast.success('Gift added to cart!');
        // Update cart count in navbar
        if (response.data.cart_count !== undefined) {
          window.cartCount = response.data.cart_count;
          // Dispatch event to update navbar
          window.dispatchEvent(new CustomEvent('cartUpdated', { detail: { count: response.data.cart_count } }));
        }
        onClose();
      } else {
        throw new Error('Failed to add to cart');
      }
      
    } catch (error) {
      console.error('Add to cart error:', error);
      let message = 'Failed to add gift to cart';
      
      if (error.response?.data?.detail) {
        const detail = error.response.data.detail;
        // Handle Pydantic validation errors (array of error objects)
        if (Array.isArray(detail)) {
          message = detail.map(err => err.msg || JSON.stringify(err)).join(', ');
        } else if (typeof detail === 'string') {
          message = detail;
        } else {
          message = JSON.stringify(detail);
        }
      }
      
      toast.error(message);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePurchase = async (e) => {
    // Prevent default form behavior
    if (e) e.preventDefault();
    
    // Validate recipient name
    if (!formData.recipient_name || !formData.recipient_name.trim()) {
      toast.error('Please enter recipient name');
      return;
    }
    
    // For credits, email is REQUIRED
    if (productType === 'credits') {
      if (!formData.recipient_email || !formData.recipient_email.trim()) {
        toast.error('Recipient email is required for credit gifts');
        return;
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.recipient_email.trim())) {
        toast.error('Please enter a valid email address');
        return;
      }
    } else {
      // For frames, validate email if provided
      if (formData.recipient_email && formData.recipient_email.trim()) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData.recipient_email.trim())) {
          toast.error('Please enter a valid email address');
          return;
        }
      }
    }
    
    // First add to cart, then redirect to checkout
    setIsLoading(true);
    
    try {
      const frameData = selectedPackage?.frame || selectedPackage;
      const moments = selectedPackage?.moments || [];
      
      // Prepare gift data for cart
      // For credits, construct product_id from credits amount
      const productId = productType === 'credits' 
        ? `credit_${selectedPackage.credits}_${selectedPackage.price}` 
        : (frameData.id || frameData.product_id || frameData.productId);
      
      const giftData = {
        product_id: productId,
        variant_id: frameData.variantId || frameData.variant_id || null,
        title: productType === 'credits' 
          ? `${selectedPackage.credits} Credits Gift Card` 
          : (frameData.display || frameData.title),
        price: parseFloat(frameData.price || selectedPackage.price),
        quantity: 1,
        image_url: frameData.featuredImage || frameData.image_url || null,
        recipient_name: formData.recipient_name,
        recipient_email: formData.recipient_email || '',
        gift_message: formData.personal_message || '',
        delivery_date: new Date().toISOString(),
        design_template: formData.design_template,
        occasion: formData.occasion,
        holiday_subtype: formData.holiday_subtype || '',
        custom_greeting: formData.custom_greeting || '',
        selected_media: moments.map(m => ({
          id: m.id,
          type: m.type || 'video',
          thumbnail_url: m.thumbnail_url,
          source_id: m.source_id || m.id
        }))
      };
      
      console.log('🎁 Processing gift purchase:', giftData);
      
      // Get session token for authentication
      const sessionToken = localStorage.getItem('session_token');
      
      const response = await axios.post(
        `${getAPI()}/shop/cart/add-gift?user_id=${user.id}`,
        giftData,
        {
          headers: {
            'Authorization': `Bearer ${sessionToken}`
          }
        }
      );
      
      if (response.data.success) {
        // Update cart count in navbar
        if (response.data.cart_count !== undefined) {
          window.cartCount = response.data.cart_count;
        }
        
        // For credits, skip checkout page and go straight to payment
        if (productType === 'credits') {
          console.log('💳 Credit gift - proceeding directly to payment');
          toast.success('Redirecting to payment...');
          
          // Create checkout session directly
          const checkoutResponse = await axios.post(
            `${getAPI()}/shop/custom-checkout`,
            {
              user_id: user.id,
              note: formData.personal_message || ''
            },
            {
              headers: {
                'Authorization': `Bearer ${sessionToken}`
              }
            }
          );
          
          if (checkoutResponse.data.success && checkoutResponse.data.checkout_url) {
            console.log('🚀 Redirecting to payment:', checkoutResponse.data.checkout_url);
            window.location.href = checkoutResponse.data.checkout_url;
          } else {
            throw new Error('Failed to create checkout session');
          }
        } else {
          // For frames, redirect to checkout page
          toast.success('Redirecting to checkout...');
          window.location.href = '/checkout';
        }
      } else {
        throw new Error('Failed to add to cart');
      }
      
    } catch (error) {
      console.error('Purchase error:', error);
      let message = 'Failed to create checkout';
      
      if (error.response?.data?.detail) {
        const detail = error.response.data.detail;
        // Handle Pydantic validation errors (array of error objects)
        if (Array.isArray(detail)) {
          message = detail.map(err => err.msg || JSON.stringify(err)).join(', ');
        } else if (typeof detail === 'string') {
          message = detail;
        } else {
          message = JSON.stringify(detail);
        }
      }
      
      toast.error(message);
      setIsLoading(false);
    }
  };

  const getSelectedTemplate = () => {
    return designTemplates.find(t => t.id === formData.design_template) || designTemplates[0];
  };

  const generateSuggestedMessage = () => {
    const occasion = formData.design_template;
    const templates = MESSAGE_TEMPLATES[occasion] || MESSAGE_TEMPLATES.custom;
    
    // Get or initialize used indices for this occasion
    const used = usedMessageIndices[occasion] || [];
    
    // If all messages have been used, reset
    let availableIndices = [...Array(templates.length).keys()].filter(i => !used.includes(i));
    if (availableIndices.length === 0) {
      availableIndices = [...Array(templates.length).keys()];
      setUsedMessageIndices({ ...usedMessageIndices, [occasion]: [] });
    }
    
    // Pick a random message from available ones
    const randomIndex = availableIndices[Math.floor(Math.random() * availableIndices.length)];
    let message = templates[randomIndex];
    
    // Personalize with recipient name
    const recipientName = formData.recipient_name || 'there';
    message = message.replace(/{recipient}/g, recipientName);
    
    // Update used indices
    setUsedMessageIndices({
      ...usedMessageIndices,
      [occasion]: [...used, randomIndex]
    });
    
    // Update form data
    setFormData({
      ...formData,
      personal_message: message
    });
  };

  const renderStep1 = () => (
    <div className="space-y-4">
      <h3 className="text-xl font-bold text-gray-800 mb-4">{t('gift_card.step1_title')}</h3>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
        {designTemplates.map((template) => (
          <div key={template.id} className="relative">
            <button
              onClick={() => handleTemplateSelect(template.id)}
              className={`w-full p-2 rounded-xl border-2 transition-all ${
                formData.design_template === template.id
                  ? `border-blue-500 ${template.bgColor} shadow-lg scale-105`
                  : 'border-gray-200 bg-white hover:border-gray-300'
              }`}
            >
              <div className="flex flex-col items-center gap-1">
                <div className={`w-10 h-10 rounded-full bg-gradient-to-br ${template.color} flex items-center justify-center text-white`}>
                  {template.icon}
                </div>
                <span className="text-xs font-semibold text-gray-700">
                  {template.id === 'holiday' && formData.design_template === 'holiday' && formData.holiday_subtype
                    ? designTemplates.find(t => t.id === 'holiday')?.subOptions?.find(h => h.id === formData.holiday_subtype)?.name || template.name
                    : template.name}
                </span>
              </div>
            </button>
            
            {/* Holiday Sub-Options - Positioned Right Below Holiday Icon */}
            {template.id === 'holiday' && formData.design_template === 'holiday' && !formData.holiday_subtype && (
              <div className="absolute top-full left-0 right-0 mt-2 z-10 col-span-3">
                <div className="p-4 bg-gradient-to-br from-red-50 to-green-50 rounded-xl border-2 border-red-300 shadow-xl">
                  <h4 className="text-lg font-semibold text-gray-800 mb-3">{t('gift_card.choose_holiday_type')}</h4>
                  <div className="grid grid-cols-2 gap-2">
                    {designTemplates.find(t => t.id === 'holiday')?.subOptions?.map((holiday) => (
                      <button
                        key={holiday.id}
                        onClick={() => setFormData({...formData, holiday_subtype: holiday.id})}
                        className="p-3 rounded-lg border-2 border-gray-200 bg-white hover:border-gray-300 text-gray-700 transition-all text-sm"
                      >
                        {holiday.name}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Custom Greeting Input */}
      {formData.design_template === 'custom' && (
        <div className="mt-6 p-4 bg-gradient-to-br from-purple-50 to-blue-50 rounded-xl border border-purple-200">
          <h4 className="text-lg font-semibold text-gray-800 mb-3">Customize Your Greeting</h4>
          <div className="space-y-3">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Main Greeting
              </label>
              <input
                type="text"
                name="custom_greeting"
                value={formData.custom_greeting}
                onChange={handleInputChange}
                onKeyDown={handleInputKeyDown}
                placeholder="e.g., Congratulations!, Happy Day!, etc."
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );

  const renderStep2 = () => {
    const frameData = selectedPackage?.frame || selectedPackage;
    const moments = selectedPackage?.moments || [];
    const displayMoments = moments.slice(0, 5);
    const template = getSelectedTemplate();
    
    return (
    <div className="space-y-6">
      <div>
        <h3 className="text-xl font-bold text-gray-800 mb-1">Review & Sign Your Gift</h3>
        <p className="text-sm text-gray-600 mb-4">
          Preview exactly what {formData.recipient_name || 'the recipient'} will see in their email
        </p>
      </div>
      
      {/* Beautiful Email Preview - Exactly what recipient sees */}
      <div className={`${template.bgColor} rounded-xl sm:rounded-2xl overflow-hidden border-2 border-gray-200 shadow-xl`}>
        {/* Animated Header with Theme */}
        <div className={`relative bg-gradient-to-br ${template.color} p-4 sm:p-8 text-center overflow-hidden`}>
          {/* Theme-Specific Animated Background Elements */}
          <div className="absolute inset-0 opacity-30 pointer-events-none">
            {/* Birthday Animation - Balloons & Confetti */}
            {template.name === 'Birthday' && (
              <>
                {/* Confetti */}
                {[...Array(15)].map((_, i) => (
                  <div
                    key={`confetti-${i}`}
                    className="absolute w-2 h-2 bg-white rounded-full"
                    style={{
                      left: `${Math.random() * 100}%`,
                      top: '-10px',
                      animation: `fall ${2 + Math.random() * 3}s ease-in-out ${Math.random() * 2}s infinite`,
                      animationDelay: `${Math.random() * 2}s`
                    }}
                  />
                ))}
                {/* Balloons Rising */}
                {[...Array(6)].map((_, i) => (
                  <div
                    key={`balloon-${i}`}
                    className="absolute text-4xl"
                    style={{
                      left: `${10 + i * 15}%`,
                      bottom: '-50px',
                      animation: `rise ${4 + Math.random() * 2}s ease-in-out ${i * 0.5}s infinite`
                    }}
                  >
                    🎈
                  </div>
                ))}
                <style jsx>{`
                  @keyframes fall {
                    0% { transform: translateY(0) rotate(0deg); }
                    100% { transform: translateY(150vh) rotate(360deg); }
                  }
                  @keyframes rise {
                    0% { transform: translateY(0) rotate(-5deg); }
                    50% { transform: translateY(-80px) rotate(5deg); }
                    100% { transform: translateY(-160px) rotate(-5deg); opacity: 0; }
                  }
                `}</style>
              </>
            )}
            
            {/* Holiday Animation - Snowflakes */}
            {template.name === 'Holiday' && (
              <>
                {[...Array(20)].map((_, i) => (
                  <div
                    key={`snowflake-${i}`}
                    className="absolute text-white text-2xl"
                    style={{
                      left: `${Math.random() * 100}%`,
                      top: `-${Math.random() * 20}px`,
                      animation: `snowfall ${3 + Math.random() * 4}s linear ${Math.random() * 3}s infinite`,
                      opacity: 0.6 + Math.random() * 0.4
                    }}
                  >
                    ❄
                  </div>
                ))}
                <style jsx>{`
                  @keyframes snowfall {
                    0% { transform: translateY(0) rotate(0deg); }
                    100% { transform: translateY(150vh) rotate(360deg); }
                  }
                `}</style>
              </>
            )}
            
            {/* Anniversary Animation - Floating Hearts */}
            {template.name === 'Anniversary' && (
              <>
                {[...Array(12)].map((_, i) => (
                  <div
                    key={`heart-${i}`}
                    className="absolute text-3xl"
                    style={{
                      left: `${Math.random() * 100}%`,
                      bottom: '-40px',
                      animation: `floatHeart ${4 + Math.random() * 3}s ease-in-out ${Math.random() * 2}s infinite`
                    }}
                  >
                    ❤️
                  </div>
                ))}
                <style jsx>{`
                  @keyframes floatHeart {
                    0% { transform: translateY(0) scale(0.8); opacity: 0; }
                    10% { opacity: 1; }
                    90% { opacity: 1; }
                    100% { transform: translateY(-180px) scale(1.2); opacity: 0; }
                  }
                `}</style>
              </>
            )}
            
            {/* Celebration Animation - Sparkling Stars */}
            {template.name === 'Celebration' && (
              <>
                {[...Array(18)].map((_, i) => (
                  <div
                    key={`star-${i}`}
                    className="absolute text-yellow-200 text-2xl"
                    style={{
                      left: `${Math.random() * 100}%`,
                      top: `${Math.random() * 100}%`,
                      animation: `sparkle ${1 + Math.random() * 2}s ease-in-out ${Math.random() * 2}s infinite`
                    }}
                  >
                    ✨
                  </div>
                ))}
                {/* Firework Bursts */}
                {[...Array(5)].map((_, i) => (
                  <div
                    key={`burst-${i}`}
                    className="absolute w-1 h-1 bg-yellow-200 rounded-full"
                    style={{
                      left: '50%',
                      top: '50%',
                      animation: `burst ${2}s ease-out ${i * 0.4}s infinite`
                    }}
                  />
                ))}
                <style jsx>{`
                  @keyframes sparkle {
                    0%, 100% { transform: scale(0.5) rotate(0deg); opacity: 0.3; }
                    50% { transform: scale(1.5) rotate(180deg); opacity: 1; }
                  }
                  @keyframes burst {
                    0% { transform: translate(0, 0) scale(1); opacity: 1; }
                    100% { transform: translate(${Math.random() * 200 - 100}px, ${Math.random() * 200 - 100}px) scale(0); opacity: 0; }
                  }
                `}</style>
              </>
            )}
            
            {/* Thank You Animation - Gentle Hearts */}
            {template.name === 'Thank You' && (
              <>
                {[...Array(10)].map((_, i) => (
                  <div
                    key={`thankyou-${i}`}
                    className="absolute text-2xl"
                    style={{
                      left: `${20 + i * 8}%`,
                      top: `${20 + (i % 3) * 25}%`,
                      animation: `gentlePulse ${2 + Math.random()}s ease-in-out ${i * 0.3}s infinite`
                    }}
                  >
                    💙
                  </div>
                ))}
                <style jsx>{`
                  @keyframes gentlePulse {
                    0%, 100% { transform: scale(0.8); opacity: 0.4; }
                    50% { transform: scale(1.3); opacity: 0.9; }
                  }
                `}</style>
              </>
            )}
            
            {/* Mother's Day Animation - Floating Flowers */}
            {template.name === "Mother's Day" && (
              <>
                {[...Array(15)].map((_, i) => (
                  <div
                    key={`flower-${i}`}
                    className="absolute text-3xl"
                    style={{
                      left: `${Math.random() * 100}%`,
                      bottom: '-50px',
                      animation: `floatFlower ${4 + Math.random() * 3}s ease-in-out ${Math.random() * 2}s infinite`
                    }}
                  >
                    🌸
                  </div>
                ))}
                <style jsx>{`
                  @keyframes floatFlower {
                    0% { transform: translateY(0) rotate(0deg); opacity: 0; }
                    10% { opacity: 1; }
                    90% { opacity: 1; }
                    100% { transform: translateY(-200px) rotate(360deg); opacity: 0; }
                  }
                `}</style>
              </>
            )}
            
            {/* Father's Day Animation - Rising Stars */}
            {template.name === "Father's Day" && (
              <>
                {[...Array(12)].map((_, i) => (
                  <div
                    key={`star-${i}`}
                    className="absolute text-2xl text-yellow-300"
                    style={{
                      left: `${Math.random() * 100}%`,
                      top: `${Math.random() * 100}%`,
                      animation: `twinkleStar ${2 + Math.random()}s ease-in-out ${Math.random() * 2}s infinite`
                    }}
                  >
                    ⭐
                  </div>
                ))}
                <style jsx>{`
                  @keyframes twinkleStar {
                    0%, 100% { transform: scale(0.5); opacity: 0.3; }
                    50% { transform: scale(1.3); opacity: 1; }
                  }
                `}</style>
              </>
            )}
            
            {/* Wedding Animation - Floating Petals */}
            {template.name === 'Wedding' && (
              <>
                {[...Array(20)].map((_, i) => (
                  <div
                    key={`petal-${i}`}
                    className="absolute text-2xl"
                    style={{
                      left: `${Math.random() * 100}%`,
                      top: '-20px',
                      animation: `fallPetal ${4 + Math.random() * 3}s ease-in ${Math.random() * 3}s infinite`
                    }}
                  >
                    🌹
                  </div>
                ))}
                <style jsx>{`
                  @keyframes fallPetal {
                    0% { transform: translateY(0) rotate(0deg); opacity: 1; }
                    100% { transform: translateY(180vh) rotate(720deg); opacity: 0; }
                  }
                `}</style>
              </>
            )}
            
            {/* Engagement Animation - Sparkling Diamonds */}
            {template.name === 'Engagement' && (
              <>
                {[...Array(15)].map((_, i) => (
                  <div
                    key={`diamond-${i}`}
                    className="absolute text-2xl"
                    style={{
                      left: `${Math.random() * 100}%`,
                      top: `${Math.random() * 100}%`,
                      animation: `sparkle ${1.5 + Math.random()}s ease-in-out ${Math.random() * 2}s infinite`
                    }}
                  >
                    💎
                  </div>
                ))}
                <style jsx>{`
                  @keyframes sparkle {
                    0%, 100% { transform: scale(0.3) rotate(0deg); opacity: 0.2; }
                    50% { transform: scale(1.2) rotate(180deg); opacity: 1; }
                  }
                `}</style>
              </>
            )}
            
            {/* Baby Shower Animation - Floating Bubbles */}
            {template.name === 'Baby Shower' && (
              <>
                {[...Array(12)].map((_, i) => (
                  <div
                    key={`bubble-${i}`}
                    className="absolute w-6 h-6 rounded-full bg-white/30 border-2 border-white/50"
                    style={{
                      left: `${Math.random() * 100}%`,
                      bottom: '-30px',
                      animation: `floatBubble ${5 + Math.random() * 3}s ease-in-out ${Math.random() * 2}s infinite`
                    }}
                  />
                ))}
                <style jsx>{`
                  @keyframes floatBubble {
                    0% { transform: translateY(0) scale(0.5); opacity: 0; }
                    10% { opacity: 1; }
                    90% { opacity: 1; }
                    100% { transform: translateY(-200px) scale(1.2); opacity: 0; }
                  }
                `}</style>
              </>
            )}
            
            {/* New Baby Animation - Twinkling Stars */}
            {template.name === 'New Baby' && (
              <>
                {[...Array(18)].map((_, i) => (
                  <div
                    key={`babystar-${i}`}
                    className="absolute text-2xl"
                    style={{
                      left: `${Math.random() * 100}%`,
                      top: `${Math.random() * 100}%`,
                      animation: `twinkle ${2 + Math.random()}s ease-in-out ${Math.random() * 2}s infinite`
                    }}
                  >
                    ⭐
                  </div>
                ))}
                <style jsx>{`
                  @keyframes twinkle {
                    0%, 100% { transform: scale(0.5); opacity: 0.3; }
                    50% { transform: scale(1.2); opacity: 1; }
                  }
                `}</style>
              </>
            )}
            
            {/* Graduation Animation - Confetti Burst */}
            {template.name === 'Graduation' && (
              <>
                {[...Array(25)].map((_, i) => (
                  <div
                    key={`gradconfetti-${i}`}
                    className="absolute w-2 h-4 bg-gradient-to-b from-yellow-300 to-yellow-500 rounded-sm"
                    style={{
                      left: `${Math.random() * 100}%`,
                      top: '-20px',
                      animation: `fallConfetti ${3 + Math.random() * 2}s linear ${Math.random() * 2}s infinite`
                    }}
                  />
                ))}
                {[...Array(5)].map((_, i) => (
                  <div
                    key={`gradhat-${i}`}
                    className="absolute text-3xl"
                    style={{
                      left: `${20 + i * 15}%`,
                      top: '-40px',
                      animation: `fallSlow ${4 + Math.random()}s ease-in ${i * 0.5}s infinite`
                    }}
                  >
                    🎓
                  </div>
                ))}
                <style jsx>{`
                  @keyframes fallConfetti {
                    0% { transform: translateY(0) rotate(0deg); }
                    100% { transform: translateY(180vh) rotate(720deg); }
                  }
                  @keyframes fallSlow {
                    0% { transform: translateY(0) rotate(0deg); opacity: 1; }
                    100% { transform: translateY(150vh) rotate(360deg); opacity: 0; }
                  }
                `}</style>
              </>
            )}
            
            {/* Retirement Animation - Peaceful Doves */}
            {template.name === 'Retirement' && (
              <>
                {[...Array(8)].map((_, i) => (
                  <div
                    key={`dove-${i}`}
                    className="absolute text-3xl"
                    style={{
                      left: `${-10 + i * 15}%`,
                      top: `${30 + (i % 2) * 20}%`,
                      animation: `flyAcross ${6 + Math.random() * 2}s linear ${i * 0.8}s infinite`
                    }}
                  >
                    🕊️
                  </div>
                ))}
                <style jsx>{`
                  @keyframes flyAcross {
                    0% { transform: translateX(0) translateY(0); }
                    50% { transform: translateX(50vw) translateY(-20px); }
                    100% { transform: translateX(100vw) translateY(0); opacity: 0; }
                  }
                `}</style>
              </>
            )}
            
            {/* Housewarming Animation - Floating Keys */}
            {template.name === 'Housewarming' && (
              <>
                {[...Array(10)].map((_, i) => (
                  <div
                    key={`key-${i}`}
                    className="absolute text-2xl"
                    style={{
                      left: `${Math.random() * 100}%`,
                      top: `${Math.random() * 100}%`,
                      animation: `floatKey ${3 + Math.random() * 2}s ease-in-out ${Math.random() * 2}s infinite`
                    }}
                  >
                    🔑
                  </div>
                ))}
                <style jsx>{`
                  @keyframes floatKey {
                    0%, 100% { transform: translateY(0) rotate(-10deg); }
                    50% { transform: translateY(-30px) rotate(10deg); }
                  }
                `}</style>
              </>
            )}
            
            {/* Memorial Animation - Gentle Candles */}
            {template.name === 'In Remembrance' && (
              <>
                {[...Array(8)].map((_, i) => (
                  <div
                    key={`candle-${i}`}
                    className="absolute text-2xl"
                    style={{
                      left: `${15 + i * 10}%`,
                      top: `${40 + (i % 2) * 20}%`,
                      animation: `candleFlicker ${2 + Math.random()}s ease-in-out ${i * 0.3}s infinite`
                    }}
                  >
                    🕯️
                  </div>
                ))}
                <style jsx>{`
                  @keyframes candleFlicker {
                    0%, 100% { transform: scale(1); opacity: 0.7; }
                    50% { transform: scale(1.1); opacity: 1; }
                  }
                `}</style>
              </>
            )}
            
            {/* Pet Celebration Animation - Paw Prints */}
            {template.name === 'Pet Celebration' && (
              <>
                {[...Array(15)].map((_, i) => (
                  <div
                    key={`paw-${i}`}
                    className="absolute text-2xl"
                    style={{
                      left: `${Math.random() * 100}%`,
                      bottom: '-30px',
                      animation: `walkPaw ${4 + Math.random() * 2}s ease-in ${Math.random() * 2}s infinite`
                    }}
                  >
                    🐾
                  </div>
                ))}
                <style jsx>{`
                  @keyframes walkPaw {
                    0% { transform: translateY(0) scale(0.5); opacity: 0; }
                    10% { opacity: 1; }
                    90% { opacity: 1; }
                    100% { transform: translateY(-180px) scale(1); opacity: 0; }
                  }
                `}</style>
              </>
            )}
            
            {/* Farewell Animation - Waving Hands */}
            {template.name === 'Farewell' && (
              <>
                {[...Array(10)].map((_, i) => (
                  <div
                    key={`wave-${i}`}
                    className="absolute text-3xl"
                    style={{
                      left: `${10 + i * 9}%`,
                      top: `${30 + (i % 3) * 20}%`,
                      animation: `wave ${2 + Math.random()}s ease-in-out ${i * 0.2}s infinite`
                    }}
                  >
                    👋
                  </div>
                ))}
                <style jsx>{`
                  @keyframes wave {
                    0%, 100% { transform: rotate(-20deg); }
                    50% { transform: rotate(20deg); }
                  }
                `}</style>
              </>
            )}
            
            {/* Custom Animation - Creative Brush Strokes */}
            {template.name === 'Custom' && (
              <>
                {[...Array(8)].map((_, i) => (
                  <div
                    key={`brush-${i}`}
                    className="absolute w-16 h-1 bg-white/40 rounded-full"
                    style={{
                      left: `${Math.random() * 100}%`,
                      top: `${Math.random() * 100}%`,
                      transform: `rotate(${Math.random() * 360}deg)`,
                      animation: `brushStroke ${3 + Math.random() * 2}s ease-in-out ${Math.random() * 2}s infinite`
                    }}
                  />
                ))}
                <style jsx>{`
                  @keyframes brushStroke {
                    0%, 100% { transform: translateX(0) scale(0.5); opacity: 0.2; }
                    50% { transform: translateX(30px) scale(1); opacity: 0.8; }
                  }
                `}</style>
              </>
            )}
          </div>
          
          {/* Main Icon - Large and Animated */}
          <div className="relative">
            <div className="w-16 h-16 sm:w-24 sm:h-24 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center mx-auto mb-2 sm:mb-4" 
                 style={{
                   animation: template.name === 'Birthday' ? 'bounce 2s infinite' :
                             template.name === 'Holiday' ? 'spin 8s linear infinite' :
                             template.name === 'Anniversary' ? 'heartbeat 1.5s ease-in-out infinite' :
                             template.name === 'Celebration' ? 'tada 2s ease-in-out infinite' :
                             template.name === 'Thank You' ? 'pulse 2s ease-in-out infinite' :
                             template.name === "Mother's Day" ? 'pulse 2s ease-in-out infinite' :
                             template.name === "Father's Day" ? 'bounce 2s infinite' :
                             template.name === 'Wedding' ? 'heartbeat 1.5s ease-in-out infinite' :
                             template.name === 'Engagement' ? 'tada 2s ease-in-out infinite' :
                             template.name === 'Baby Shower' ? 'bounce 2s infinite' :
                             template.name === 'New Baby' ? 'bounce 2s infinite' :
                             template.name === 'Graduation' ? 'tada 2s ease-in-out infinite' :
                             template.name === 'Retirement' ? 'pulse 2s ease-in-out infinite' :
                             template.name === 'Housewarming' ? 'swing 3s ease-in-out infinite' :
                             template.name === 'In Remembrance' ? 'pulse 2s ease-in-out infinite' :
                             template.name === 'Pet Celebration' ? 'bounce 2s infinite' :
                             template.name === 'Farewell' ? 'wave 2s ease-in-out infinite' :
                             'swing 3s ease-in-out infinite'
                 }}>
              {template.name === 'Birthday' && (
                <svg className="w-10 h-10 sm:w-14 sm:h-14 text-white" fill="currentColor" viewBox="0 0 24 24">
                  {/* Simple Birthday Cake with Candles */}
                  {/* Candle flames */}
                  <ellipse cx="8" cy="4" rx="1" ry="1.5" fill="#FFD700"/>
                  <ellipse cx="12" cy="3" rx="1" ry="1.5" fill="#FFD700"/>
                  <ellipse cx="16" cy="4" rx="1" ry="1.5" fill="#FFD700"/>
                  {/* Candles */}
                  <rect x="7.5" y="5" width="1" height="3" fill="white" opacity="0.9"/>
                  <rect x="11.5" y="4" width="1" height="4" fill="white" opacity="0.9"/>
                  <rect x="15.5" y="5" width="1" height="3" fill="white" opacity="0.9"/>
                  {/* Top cake layer */}
                  <path d="M4 9 L20 9 L19 13 L5 13 Z" fill="white"/>
                  <rect x="5" y="13" width="14" height="1" fill="white" opacity="0.7"/>
                  {/* Bottom cake layer */}
                  <path d="M3 14 L21 14 L20 19 L4 19 Z" fill="white"/>
                  <rect x="4" y="19" width="16" height="1" fill="white" opacity="0.7"/>
                  {/* Decorative frosting */}
                  <circle cx="7" cy="11" r="0.5" fill="#FFD700"/>
                  <circle cx="12" cy="11" r="0.5" fill="#FFD700"/>
                  <circle cx="17" cy="11" r="0.5" fill="#FFD700"/>
                  <circle cx="6" cy="16" r="0.5" fill="#FFD700"/>
                  <circle cx="10" cy="16" r="0.5" fill="#FFD700"/>
                  <circle cx="14" cy="16" r="0.5" fill="#FFD700"/>
                  <circle cx="18" cy="16" r="0.5" fill="#FFD700"/>
                </svg>
              )}
              {template.name === 'Holiday' && (
                <svg className="w-14 h-14 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
                </svg>
              )}
              {template.name === 'Anniversary' && (
                <svg className="w-14 h-14 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
                </svg>
              )}
              {template.name === 'Celebration' && (
                <svg className="w-14 h-14 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
                </svg>
              )}
              {template.name === 'Thank You' && (
                <svg className="w-14 h-14 text-white" fill="currentColor" viewBox="0 0 24 24">
                  {/* Thumbs up */}
                  <path d="M14 9V5a3 3 0 00-3-3l-4 9v11h11.28a2 2 0 002-1.7l1.38-9a2 2 0 00-2-2.3zM7 22H4a2 2 0 01-2-2v-7a2 2 0 012-2h3v11z"/>
                </svg>
              )}
              {template.name === "Mother's Day" && (
                <svg className="w-16 h-16 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <circle cx="12" cy="10" r="2"/>
                  <path d="M12 4C10.9 4 10 4.9 10 6C10 6.3 10.1 6.6 10.2 6.9C9.6 6.3 8.8 6 8 6C6.9 6 6 6.9 6 8C6 9.1 6.9 10 8 10C8.8 10 9.6 9.7 10.2 9.1C10.1 9.4 10 9.7 10 10C10 10.3 10.1 10.6 10.2 10.9C9.6 10.3 8.8 10 8 10C6.9 10 6 10.9 6 12C6 13.1 6.9 14 8 14C8.8 14 9.6 13.7 10.2 13.1C10.1 13.4 10 13.7 10 14C10 15.1 10.9 16 12 16C13.1 16 14 15.1 14 14C14 13.7 13.9 13.4 13.8 13.1C14.4 13.7 15.2 14 16 14C17.1 14 18 13.1 18 12C18 10.9 17.1 10 16 10C15.2 10 14.4 10.3 13.8 10.9C13.9 10.6 14 10.3 14 10C14 9.7 13.9 9.4 13.8 9.1C14.4 9.7 15.2 10 16 10C17.1 10 18 9.1 18 8C18 6.9 17.1 6 16 6C15.2 6 14.4 6.3 13.8 6.9C13.9 6.6 14 6.3 14 6C14 4.9 13.1 4 12 4Z"/>
                  <path d="M12 16L12 22" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
                </svg>
              )}
              {template.name === "Father's Day" && (
                <svg className="w-16 h-16 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <rect x="10" y="2" width="4" height="1.5" rx="0.3"/>
                  <path d="M10.5 3.5 L10 4.5 L9.5 6 L9 8 L10 16 L11 20 L12 22 L13 20 L14 16 L15 8 L14.5 6 L14 4.5 L13.5 3.5 Z"/>
                  <path d="M10.5 4 L11.5 3.5 L12.5 3.5 L13.5 4 L13 5 L12 6 L11 5 Z" opacity="0.4"/>
                </svg>
              )}
              {template.name === 'Wedding' && (
                <svg className="w-16 h-16 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <circle cx="9" cy="12" r="5" strokeWidth="2"/>
                  <circle cx="15" cy="12" r="5" strokeWidth="2"/>
                  <path d="M11 12C11 14 10 15 8 15C6 15 5 14 5 12C5 10 6 9 8 9C10 9 11 10 11 12Z" fill="none" strokeWidth="1"/>
                  <path d="M19 12C19 14 18 15 16 15C14 15 13 14 13 12C13 10 14 9 16 9C18 9 19 10 19 12Z" fill="none" strokeWidth="1"/>
                </svg>
              )}
              {template.name === 'Engagement' && (
                <svg className="w-16 h-16 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <circle cx="12" cy="15" r="6" fill="none" stroke="currentColor" strokeWidth="2"/>
                  <path d="M9 6L12 3L15 6L13 9L12 10L11 9L9 6Z"/>
                  <path d="M12 10L12 12" stroke="currentColor" strokeWidth="2"/>
                </svg>
              )}
              {template.name === 'Baby Shower' && (
                <svg className="w-16 h-16 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <rect x="6" y="10" width="12" height="10" fill="none" stroke="currentColor" strokeWidth="2"/>
                  <path d="M6 10L18 10L18 12L6 12Z"/>
                  <path d="M12 4C10.5 4 10 5 10 6L10 10L14 10L14 6C14 5 13.5 4 12 4Z"/>
                  <circle cx="10" cy="6" r="1.5"/>
                  <circle cx="14" cy="6" r="1.5"/>
                  <line x1="12" y1="10" x2="12" y2="20" stroke="currentColor" strokeWidth="2"/>
                </svg>
              )}
              {template.name === 'New Baby' && (
                <svg className="w-16 h-16 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <circle cx="12" cy="8" r="4" strokeWidth="2"/>
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 21v-2a4 4 0 014-4h4a4 4 0 014 4v2"/>
                  <circle cx="10" cy="7.5" r="0.5" fill="currentColor"/>
                  <circle cx="14" cy="7.5" r="0.5" fill="currentColor"/>
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10c1 0 1.5 0.5 1.5 1"/>
                </svg>
              )}
              {template.name === 'Graduation' && (
                <svg className="w-16 h-16 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 3L2 8L12 13L22 8L12 3Z"/>
                  <path d="M12 13L6 10V14C6 16 8 18 12 18C16 18 18 16 18 14V10L12 13Z" opacity="0.7"/>
                  <path d="M20 9V15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                </svg>
              )}
              {template.name === 'Retirement' && (
                <svg className="w-16 h-16 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
                  <circle cx="12" cy="8" r="1.5" fill="currentColor"/>
                </svg>
              )}
              {template.name === 'Housewarming' && (
                <svg className="w-16 h-16 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
                </svg>
              )}
              {template.name === 'In Remembrance' && (
                <svg className="w-16 h-16 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <ellipse cx="12" cy="6" rx="2" ry="3" opacity="0.6"/>
                  <path d="M12 4C11.5 4 11 5 11 6C11 7 11.5 8 12 8C12.5 8 13 7 13 6C13 5 12.5 4 12 4Z"/>
                  <rect x="10" y="8" width="4" height="12" rx="0.5"/>
                  <ellipse cx="12" cy="20" rx="3" ry="1" opacity="0.4"/>
                  <path d="M9 20L9 21L15 21L15 20" stroke="currentColor" strokeWidth="0.5"/>
                </svg>
              )}
              {template.name === 'Pet Celebration' && (
                <svg className="w-16 h-16 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <ellipse cx="12" cy="16" rx="3.5" ry="4"/>
                  <ellipse cx="7.5" cy="10" rx="1.8" ry="2.5"/>
                  <ellipse cx="11" cy="8" rx="1.8" ry="2.5"/>
                  <ellipse cx="14.5" cy="8" rx="1.8" ry="2.5"/>
                  <ellipse cx="17" cy="10" rx="1.8" ry="2.5"/>
                </svg>
              )}
              {template.name === 'Farewell' && (
                <svg className="w-16 h-16 text-white" fill="currentColor" viewBox="0 0 24 24">
                  {/* Waving hand */}
                  <path d="M8 14C8 12 9 11 10 11C11 11 11 12 11 13L11 17L10 18L8 17L8 14Z"/>
                  <path d="M11 13L11 8C11 6 12 5 13 5C14 5 14 6 14 8L14 13"/>
                  <path d="M14 13L14 6C14 4.5 15 4 16 4C17 4 17 5 17 6L17 13"/>
                  <path d="M17 13L17 8C17 7 18 7 18.5 7.5C19 8 19 9 19 10L19 14C19 16 18 18 16 19C14 20 11 19 10 18L8 17"/>
                  <path d="M13 3L13.5 1" stroke="white" strokeWidth="1.2" strokeLinecap="round" opacity="0.7"/>
                  <path d="M16 3L17 1" stroke="white" strokeWidth="1.2" strokeLinecap="round" opacity="0.7"/>
                  <path d="M19 5L20.5 3.5" stroke="white" strokeWidth="1.2" strokeLinecap="round" opacity="0.7"/>
                </svg>
              )}
              {template.name === 'Custom' && (
                <svg className="w-14 h-14 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01" />
                </svg>
              )}
              <style jsx>{`
                @keyframes heartbeat {
                  0%, 100% { transform: scale(1); }
                  25% { transform: scale(1.1); }
                  50% { transform: scale(1); }
                  75% { transform: scale(1.15); }
                }
                @keyframes tada {
                  0%, 100% { transform: scale(1) rotate(0deg); }
                  10%, 20% { transform: scale(0.9) rotate(-3deg); }
                  30%, 50%, 70%, 90% { transform: scale(1.1) rotate(3deg); }
                  40%, 60%, 80% { transform: scale(1.1) rotate(-3deg); }
                }
                @keyframes swing {
                  0%, 100% { transform: rotate(0deg); }
                  25% { transform: rotate(5deg); }
                  75% { transform: rotate(-5deg); }
                }
              `}</style>
            </div>
            
            <h2 className="text-2xl sm:text-4xl font-bold text-white mb-2 drop-shadow-lg">
              {template.name === 'Birthday' && 'Happy Birthday!'}
              {template.name === 'Holiday' && (() => {
                const selectedHoliday = template.subOptions?.find(h => h.id === formData.holiday_subtype);
                return selectedHoliday ? selectedHoliday.greeting : 'Happy Holidays!';
              })()}
              {template.name === 'Anniversary' && 'Happy Anniversary!'}
              {template.name === 'Celebration' && 'Congratulations!'}
              {template.name === 'Thank You' && 'Thank You!'}
              {template.name === "Mother's Day" && "Happy Mother's Day!"}
              {template.name === "Father's Day" && "Happy Father's Day!"}
              {template.name === 'Wedding' && 'Congratulations on Your Wedding!'}
              {template.name === 'Engagement' && 'Congratulations on Your Engagement!'}
              {template.name === 'Baby Shower' && 'Celebrating Your Baby Shower!'}
              {template.name === 'New Baby' && 'Welcome to the World!'}
              {template.name === 'Graduation' && 'Congratulations Graduate!'}
              {template.name === 'Retirement' && 'Happy Retirement!'}
              {template.name === 'Housewarming' && 'Welcome Home!'}
              {template.name === 'In Remembrance' && 'In Loving Memory'}
              {template.name === 'Pet Celebration' && 'Celebrating Your Special Pet!'}
              {template.name === 'Farewell' && 'Farewell & Best Wishes!'}
              {template.name === 'Custom' && (formData.custom_greeting || 'You Received a Gift!')}
            </h2>
            
            <p className="text-white/90 text-sm sm:text-lg mb-4">From: <input 
              type="text"
              name="from_name"
              value={formData.from_name}
              onChange={handleInputChange}
              onKeyDown={handleInputKeyDown}
              placeholder="Your name"
              className="inline-block px-2 sm:px-3 py-1 text-sm sm:text-base border-b-2 border-white/50 bg-white/10 backdrop-blur-sm focus:border-white focus:bg-white/20 focus:outline-none font-semibold text-white text-center min-w-[100px] sm:min-w-[140px] rounded transition-all"
            /></p>
          </div>
        </div>
        
        {/* Gift Content */}
        <div className="bg-white p-4 sm:p-6 space-y-4 sm:space-y-5">
          <p className="text-base sm:text-lg text-gray-800">
            Hi <span className="font-semibold text-purple-700">{formData.recipient_name || '[Recipient Name]'}</span>,
          </p>
          
          {/* {t('gift_card.personal_message_label')} */}
          {formData.personal_message && (
            <div className="relative p-4 bg-gradient-to-br from-amber-50 to-orange-50 rounded-xl border-l-4 border-orange-400">
              <div className="absolute top-2 left-2 text-2xl opacity-20">"</div>
              <p className="text-gray-800 italic text-base px-2">{formData.personal_message}</p>
              <div className="absolute bottom-2 right-2 text-2xl opacity-20">"</div>
            </div>
          )}
          
          <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
            {productType === 'credits' ? (
              <>
                <span className="font-semibold">{formData.from_name || '[Your Name]'}</span> sent you a special gift - <span className="font-semibold text-purple-700">{selectedPackage?.credits || 'Magic Moments'} Credits</span> to create magical animated moments!
              </>
            ) : (
              <>
                <span className="font-semibold">{formData.from_name || '[Your Name]'}</span> sent you a special gift - a <span className="font-semibold text-purple-700">Magic Moments Digital Frame</span> {productType === 'frame' && moments.length > 0 && (
                  <>pre-loaded with <span className="font-semibold">{moments.length} cherished moment{moments.length !== 1 ? 's' : ''}</span></>
                )}!
              </>
            )}
          </p>
          
          {/* Frame Details Card */}
          {productType === 'frame' && frameData && (
            <div className="bg-gradient-to-br from-purple-50 to-blue-50 rounded-xl p-4 sm:p-5 border-2 border-purple-200 mt-4">
              <div className="flex gap-3 sm:gap-4 items-start mb-3">
                {frameData.featuredImage && (
                  <div className="w-24 h-24 sm:w-32 sm:h-32 flex-shrink-0 rounded-lg overflow-hidden border-2 border-purple-300 shadow-md bg-white p-2">
                    <img 
                      src={frameData.featuredImage} 
                      alt={frameData.display}
                      className="w-full h-full object-contain"
                    />
                  </div>
                )}
                <div className="flex-1 min-w-0">
                  <p className="font-bold text-gray-900 text-base sm:text-lg mb-2 leading-tight">{frameData.display}</p>
                  <p className="text-xs sm:text-sm text-purple-700 font-medium flex items-center gap-1">
                    <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
                    </svg>
                    Ready to display your memories
                  </p>
                </div>
              </div>
              
              {/* Moment Thumbnails */}
              {moments.length > 0 && (
                <div className="pt-3 sm:pt-4 border-t border-purple-200 mt-1">
                  <p className="text-xs sm:text-sm font-semibold text-purple-700 mb-3">
                    Pre-loaded with {moments.length} cherished moment{moments.length !== 1 ? 's' : ''}:
                  </p>
                  <div className="flex gap-2 items-center flex-wrap">
                    {displayMoments.map((moment, index) => {
                      // Try multiple thumbnail sources
                      const thumbnailUrl = moment.thumbnail_url || moment.thumbnailUrl || moment.result_url || moment.video_url;
                      
                      return (
                        <div key={index} className="w-16 h-16 rounded-lg overflow-hidden border-2 border-purple-300 flex-shrink-0 shadow-sm">
                          {thumbnailUrl ? (
                            <img 
                              src={thumbnailUrl} 
                              alt={`Moment ${index + 1}`}
                              className="w-full h-full object-cover"
                              onError={(e) => {
                                // Fallback to placeholder on error
                                e.target.style.display = 'none';
                                e.target.nextSibling.style.display = 'flex';
                              }}
                            />
                          ) : null}
                          <div className="w-full h-full bg-gradient-to-br from-purple-100 to-blue-100 flex items-center justify-center" style={{display: thumbnailUrl ? 'none' : 'flex'}}>
                            <svg className="w-7 h-7 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                            </svg>
                          </div>
                        </div>
                      );
                    })}
                    {moments.length > 5 && (
                      <div className="text-purple-600 text-sm font-medium">+{moments.length - 5} more</div>
                    )}
                  </div>
                </div>
              )}
            </div>
          )}
          
          {/* What's Next - Frame Only */}
          {productType === 'frame' && (
          <div className="bg-blue-50 rounded-xl p-4 border border-blue-200">
            <p className="text-sm text-blue-900 font-medium mb-2">📦 What's Next?</p>
            <p className="text-sm text-blue-800 mb-3">
              Your gift is being prepared and will ship soon! {formData.recipient_email && "You'll receive tracking and delivery updates at this email."}
            </p>
            <div className="flex items-start gap-2 mt-2 pt-2 border-t border-blue-200">
              <svg className="w-4 h-4 text-blue-600 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
              </svg>
              <p className="text-xs text-blue-700">
                <span className="font-semibold">A printed version of this beautiful card</span> will be included inside the frame box for your recipient to keep!
              </p>
            </div>
          </div>
          )}
          
          {/* Footer */}
          <div className="text-center pt-4 border-t border-gray-200">
            <p className="text-xs text-gray-500">
              Magic Moments - Creating Lasting Memories
            </p>
          </div>
        </div>
      </div>

      {/* Platform Showcase - Show AFTER email preview for credits */}
      {productType === 'credits' && (
        <div className="bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50 rounded-2xl p-6 border-2 border-purple-300 shadow-xl">
          <div className="text-center mb-6">
            <h4 className="text-2xl font-bold text-gray-800 mb-2 flex items-center justify-center gap-2">
              <span className="text-3xl">✨</span>
              What Your Gift Unlocks
              <span className="text-3xl">✨</span>
            </h4>
            <p className="text-base text-gray-700 font-medium">
              See how {selectedPackage?.credits} credits transform photos into magical animated moments
            </p>
          </div>
          
          {/* Video Player with Original Photo Overlay - EXACT copy of PublicVideoWatch layout */}
          <div className="bg-white rounded-xl shadow-xl overflow-visible mb-6 relative mt-10 max-w-3xl mx-auto">
            <div className="aspect-video bg-black relative overflow-hidden rounded-xl">
              <video
                src="/landing-assets/demo1-left-video.mp4"
                controls
                autoPlay
                loop
                muted
                playsInline
                className="w-full h-full"
                poster="/landing-assets/demo1-left-image.jpg"
              />
            </div>
            
            {/* Original Photo Card - Overlaid hanging off top left edge (EXACT PublicVideoWatch style) */}
            <div className="absolute -top-4 -left-2 md:-left-8 z-30">
              <div className="relative">
                <div 
                  className="bg-white shadow-2xl overflow-visible w-20 h-14 sm:w-32 sm:h-24"
                  style={{ 
                    transform: 'rotate(-5deg)',
                    boxShadow: '0 10px 40px rgba(0,0,0,0.6), inset 0 0 15px rgba(0,0,0,0.05)',
                    border: '1px solid rgba(139, 92, 46, 0.2)',
                    padding: '0.2rem'
                  }}
                >
                  <div className="absolute -top-6 sm:-top-7 left-0 right-0 bg-amber-300 text-gray-900 px-1 sm:px-2 py-0.5 sm:py-1 rounded-full font-bold shadow-lg text-center z-10 mx-1 sm:mx-2 text-[0.45rem] sm:text-[0.6rem]">
                    Original Photo
                  </div>
                  <div className="w-full h-full relative" style={{
                    border: '1px solid rgba(139, 92, 46, 0.15)',
                    boxShadow: 'inset 0 0 20px rgba(139, 92, 46, 0.08)'
                  }}>
                    <img 
                      src="/landing-assets/demo1-left-image.jpg"
                      alt="Original Photo"
                      className="w-full h-full object-cover"
                      style={{
                        filter: 'sepia(0.08) contrast(0.95) brightness(1.02)',
                        opacity: '0.98'
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Features List */}
          <div className="mt-6">
            <p className="text-center text-base font-semibold text-gray-800 mb-4">
              What You Can Do With Your Credits:
            </p>
            <div className="space-y-3">
              <div className="bg-white rounded-lg p-3 border-l-4 border-blue-500 shadow-sm flex items-start gap-3">
                <svg className="w-6 h-6 flex-shrink-0 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"/>
                </svg>
                <p className="text-sm text-gray-700 flex-1">
                  <span className="font-semibold text-blue-600">AI-Powered Animation:</span> Bring your photos to life with stunning cinematic movement and depth
                </p>
              </div>
              <div className="bg-white rounded-lg p-3 border-l-4 border-purple-600 shadow-sm flex items-start gap-3">
                <svg className="w-6 h-6 flex-shrink-0 text-purple-600" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"/>
                </svg>
                <p className="text-sm text-gray-700 flex-1">
                  <span className="font-semibold text-purple-600">Digital Frames:</span> Display your animated moments on any smart frame or digital device
                </p>
              </div>
              <div className="bg-white rounded-lg p-3 border-l-4 border-indigo-500 shadow-sm flex items-start gap-3">
                <svg className="w-6 h-6 flex-shrink-0 text-indigo-600" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z"/>
                </svg>
                <p className="text-sm text-gray-700 flex-1">
                  <span className="font-semibold text-indigo-600">Easy Sharing:</span> Share your magical moments with friends and family via link or social media
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Editable Fields Below Preview */}
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            {t('gift_card.recipient_name_label')}
          </label>
          <input
            type="text"
            name="recipient_name"
            value={formData.recipient_name}
            onChange={handleInputChange}
            onKeyDown={handleInputKeyDown}
            placeholder={t('gift_card.recipient_name_placeholder')}
            className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>

        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            {t('gift_card.recipient_email_label')} {productType === 'credits' ? <span className="text-red-500">*</span> : <span className="text-gray-400 font-normal">{t('gift_card.personal_message_optional')}</span>}
          </label>
          <input
            type="email"
            name="recipient_email"
            value={formData.recipient_email}
            onChange={handleInputChange}
            onKeyDown={handleInputKeyDown}
            placeholder={t('gift_card.recipient_email_placeholder')}
            className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
          <p className="text-xs text-gray-500 mt-1">
            {productType === 'credits' 
              ? t('gift_card.credits_instant_email')
              : t('gift_card.gift_notification_info')}
          </p>
        </div>

        <div>
          <div className="flex items-center justify-between mb-2">
            <label className="block text-sm font-semibold text-gray-700">
              {t('gift_card.personal_message_label')} <span className="text-gray-400 font-normal">{t('gift_card.personal_message_optional')}</span>
            </label>
            <button
              type="button"
              onClick={generateSuggestedMessage}
              className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-purple-600 bg-purple-50 hover:bg-purple-100 rounded-lg transition-colors"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
              </svg>
              Suggest Message
            </button>
          </div>
          <textarea
            name="personal_message"
            value={formData.personal_message}
            onChange={handleInputChange}
            onKeyDown={handleInputKeyDown}
            placeholder="Write a personal message to your recipient..."
            rows={4}
            className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
          />
          <div className="flex items-center justify-between mt-1">
            <p className="text-xs text-gray-500">
              {formData.personal_message.length}/500 characters
            </p>
            <p className="text-xs text-purple-600 italic">
              💡 Click "Suggest Message" for inspiration
            </p>
          </div>
        </div>
      </div>
    </div>
  );
  };

  const renderStep3 = () => {
    const template = getSelectedTemplate();
    const frameData = selectedPackage?.frame || selectedPackage;
    const moments = selectedPackage?.moments || [];
    const displayMoments = moments.slice(0, 5);
    
    return (
      <div className="space-y-4">
        <h3 className="text-xl font-bold text-gray-800 mb-4">Review & Purchase</h3>
        
        {/* Frame Product Display */}
        {productType === 'frame' && frameData && (
          <div className="bg-white rounded-xl p-4 border-2 border-gray-200 mb-4">
            <div className="flex gap-4 mb-4">
              {/* Frame Image */}
              {frameData.featuredImage && (
                <div className="w-32 h-32 flex-shrink-0">
                  <img 
                    src={frameData.featuredImage} 
                    alt={frameData.display}
                    className="w-full h-full object-contain rounded-lg"
                  />
                </div>
              )}
              
              {/* Frame Details */}
              <div className="flex-1">
                <h4 className="font-bold text-gray-900 mb-1">{frameData.display}</h4>
                <p className="text-lg font-semibold text-purple-600">${frameData.price}</p>
              </div>
            </div>
            
            {/* Moments Preview */}
            {moments.length > 0 && (
              <div className="pt-4 border-t border-gray-200">
                <div className="flex gap-4">
                  {/* Frame Image Again for Side-by-Side with Moments */}
                  {frameData.featuredImage && (
                    <div className="w-32 h-32 flex-shrink-0 rounded-lg overflow-hidden border-2 border-purple-200">
                      <img 
                        src={frameData.featuredImage} 
                        alt="Frame"
                        className="w-full h-full object-cover"
                      />
                    </div>
                  )}
                  
                  {/* Moments Thumbnails */}
                  <div className="flex-1">
                    <p className="text-sm font-semibold text-gray-700 mb-2">
                      Includes {moments.length} moment{moments.length !== 1 ? 's' : ''}:
                    </p>
                    <div className="flex gap-2 items-center flex-wrap">
                      {displayMoments.map((moment, index) => (
                        <div key={index} className="w-16 h-16 rounded-lg overflow-hidden border border-gray-200 flex-shrink-0">
                          {moment.thumbnail_url ? (
                            <img 
                              src={moment.thumbnail_url} 
                              alt={`Moment ${index + 1}`}
                              className="w-full h-full object-cover"
                            />
                          ) : (
                            <div className="w-full h-full bg-gradient-to-br from-purple-100 to-blue-100 flex items-center justify-center">
                              <svg className="w-6 h-6 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                              </svg>
                            </div>
                          )}
                        </div>
                      ))}
                      {moments.length > 5 && (
                        <div className="text-gray-400 text-sm font-medium">...</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
        
        {/* Gift Card Preview (for credits) */}
        {productType !== 'frame' && (
        <div className={`${template.bgColor} rounded-2xl p-6 border-2 border-gray-200`}>
          <div className="text-center space-y-4">
            {/* Template Icon */}
            <div className={`w-16 h-16 rounded-full bg-gradient-to-br ${template.color} flex items-center justify-center text-white mx-auto`}>
              {template.icon}
            </div>
            
            {/* Gift Card Title */}
            <div>
              <h4 className="text-2xl font-bold text-gray-800">Magic Moments Gift Card</h4>
              <p className="text-sm text-gray-600 mt-1">{template.name} Design</p>
            </div>
            
            {/* Gift Details */}
            <div className="bg-white rounded-xl p-4">
              {productType === 'credits' ? (
                <>
                  <div className="text-3xl font-bold text-blue-600">{selectedPackage.credits}</div>
                  <div className="text-sm text-gray-600">Credits</div>
                  <div className="text-lg font-semibold text-gray-700 mt-1">${selectedPackage.price}</div>
                </>
              ) : (
                <>
                  <div className="text-xl font-bold text-purple-600">Frame + Credits Bundle</div>
                  <div className="text-sm text-gray-600">{selectedPackage.credits} Credits</div>
                  <div className="text-lg font-semibold text-gray-700 mt-1">${selectedPackage.price}</div>
                </>
              )}
            </div>
            
            {/* Recipient */}
            <div className="text-left bg-white rounded-xl p-4">
              <div className="flex items-center gap-2 mb-2">
                <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
                <span className="font-semibold text-gray-700">For: {formData.recipient_name}</span>
              </div>
              <div className="flex items-center gap-2">
                <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <span className="text-sm text-gray-600">{formData.recipient_email}</span>
              </div>
            </div>
            
            {/* Message Preview */}
            {formData.personal_message && (
              <div className="text-left bg-white rounded-xl p-4">
                <div className="flex items-start gap-2">
                  <svg className="w-5 h-5 text-gray-600 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
                  </svg>
                  <p className="text-sm text-gray-700 italic">"{formData.personal_message}"</p>
                </div>
              </div>
            )}
            
            {/* From */}
            <div className="text-sm text-gray-600">
              From: {formData.sender_name || user?.name || 'You'}
            </div>
          </div>
        </div>
        )}
        
        {/* Platform Showcase MOVED to top of review section for better visibility */}
        
        {/* Recipient & Message Info (for all gift types) */}
        <div className="bg-white rounded-xl p-4 border-2 border-gray-200">
          <div className="text-left space-y-3">
            <div className="flex items-center gap-2">
              <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
              <span className="font-semibold text-gray-700">For: {formData.recipient_name}</span>
            </div>
            {formData.recipient_email && (
              <div className="flex items-center gap-2">
                <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <span className="text-sm text-gray-600">{formData.recipient_email}</span>
              </div>
            )}
            {formData.personal_message && (
              <div className="flex items-start gap-2 mt-3 pt-3 border-t border-gray-200">
                <svg className="w-5 h-5 text-gray-600 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
                </svg>
                <p className="text-sm text-gray-700 italic">"{formData.personal_message}"</p>
              </div>
            )}
            <div className="text-sm text-gray-600 pt-3 border-t border-gray-200">
              From: {formData.sender_name || user?.name || 'You'}
            </div>
          </div>
        </div>
        
        {/* What Happens Next */}
        <div className="bg-blue-50 rounded-xl p-4 border border-blue-200">
          <h4 className="font-semibold text-blue-800 mb-3 flex items-center gap-2">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            What Happens Next?
          </h4>
          
          {productType === 'frame' ? (
            // Frame Gift Flow
            <>
              <ul className="space-y-2 text-sm text-blue-700 mb-4">
                <li className="flex items-start gap-2">
                  <svg className="w-4 h-4 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <span>Complete secure payment</span>
                </li>
                {formData.recipient_email && (
                  <li className="flex items-start gap-2">
                    <svg className="w-4 h-4 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    <span>Recipient will receive gift notification email (preview below)</span>
                  </li>
                )}
                <li className="flex items-start gap-2">
                  <svg className="w-4 h-4 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <span>Frame ships with pre-loaded moments to recipient's address</span>
                </li>
                {formData.recipient_email && (
                  <li className="flex items-start gap-2">
                    <svg className="w-4 h-4 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    <span>Recipient receives tracking & delivery notifications</span>
                  </li>
                )}
              </ul>
              
              {/* Email Preview for Gift Recipient */}
              {formData.recipient_email && (
                <div className="mt-4 pt-4 border-t border-blue-200">
                  <p className="text-xs font-semibold text-blue-800 mb-2">📧 {t('gift_card.recipient_email_label')} Preview:</p>
                  <div className="bg-white rounded-lg p-3 text-xs border border-blue-100">
                    <div className="text-center mb-2">
                      <span className="text-2xl">🎁</span>
                      <p className="font-bold text-gray-900 mt-1">You Received a Gift!</p>
                      <p className="text-gray-600 text-xs">From {formData.sender_name || user?.name || 'a friend'}</p>
                    </div>
                    {formData.personal_message && (
                      <div className="bg-amber-50 rounded p-2 my-2 border-l-2 border-amber-400">
                        <p className="text-gray-700 italic text-xs">"{formData.personal_message}"</p>
                      </div>
                    )}
                    <p className="text-gray-600 text-xs mt-2">
                      Your gift - a Magic Moments Digital Frame with {moments.length} pre-loaded moment{moments.length !== 1 ? 's' : ''} - is being prepared and will ship soon! You'll receive tracking and delivery updates at this email.
                    </p>
                  </div>
                </div>
              )}
            </>
          ) : (
            // Credit Gift Card Flow
            <ul className="space-y-2 text-sm text-blue-700">
              <li className="flex items-start gap-2">
                <svg className="w-4 h-4 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                <span>Complete secure payment</span>
              </li>
              <li className="flex items-start gap-2">
                <svg className="w-4 h-4 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                <span>Gift card emailed to recipient instantly</span>
              </li>
              <li className="flex items-start gap-2">
                <svg className="w-4 h-4 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                <span>Recipient can redeem anytime - never expires!</span>
              </li>
            </ul>
          )}
        </div>
      </div>
    );
  };

  if (!isOpen) return null;

  const modalContent = (
    <div 
      className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4 overflow-y-auto"
      style={{ zIndex: 2000 }}
      onClick={onClose}
    >
      <div 
        className="bg-white rounded-2xl w-full max-w-4xl max-h-[90vh] my-4 sm:my-8 shadow-2xl flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="bg-gradient-to-r from-blue-500 to-purple-500 text-white p-4 sm:p-6 rounded-t-2xl flex-shrink-0">
          <div className="flex items-center justify-between">
            <div className="flex-1 min-w-0 pr-2">
              <h2 className="text-lg sm:text-2xl font-bold truncate">{t('gift_flow.create_perfect_gift')}</h2>
              <p className="text-xs sm:text-sm text-blue-100 mt-1 truncate">
                {productType === 'credits' && `Send ${selectedPackage?.credits} credits as a gift`}
                {productType === 'frame' && `Send ${selectedPackage?.title || 'digital frame'} as a gift`}
                {productType === 'bundle' && `Send frame + ${selectedPackage?.credits} credits as a gift`}
              </p>
            </div>
            <button
              onClick={onClose}
              className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center hover:bg-white/30 transition-colors"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          
          {/* Progress Steps */}
          <div className="flex items-center gap-1 sm:gap-2 mt-4 sm:mt-6">
            {[1, 2].map((stepNum) => (
              <React.Fragment key={stepNum}>
                <div className="flex items-center gap-1 sm:gap-2">
                  <div
                    className={`w-7 h-7 sm:w-8 sm:h-8 rounded-full flex items-center justify-center text-xs sm:text-sm font-bold transition-all ${
                      step >= stepNum
                        ? 'bg-white text-blue-600'
                        : 'bg-white/20 text-white'
                    }`}
                  >
                    {stepNum}
                  </div>
                  <span className={`text-xs hidden sm:inline ${step >= stepNum ? 'text-white' : 'text-blue-200'}`}>
                    {stepNum === 1 && 'Design'}
                    {stepNum === 2 && 'Review & Sign'}
                  </span>
                </div>
                {stepNum < 2 && (
                  <div className={`flex-1 h-1 rounded ${step > stepNum ? 'bg-white' : 'bg-white/20'}`} />
                )}
              </React.Fragment>
            ))}
          </div>
        </div>

        {/* Content */}
        <div className="p-4 sm:p-6 overflow-y-auto flex-1">
          {step === 1 && renderStep1()}
          {step === 2 && renderStep2()}
        </div>

        {/* Footer */}
        <div className="border-t border-gray-200 p-4 sm:p-6 flex items-center justify-between gap-2 sm:gap-4 flex-shrink-0 bg-white rounded-b-2xl">
          <button
            onClick={() => {
              if (step === 1) {
                onClose();
              } else {
                setStep(step - 1);
              }
            }}
            className="px-4 sm:px-6 py-2 text-sm sm:text-base text-gray-600 hover:text-gray-800 font-semibold transition-colors"
            disabled={isLoading}
          >
            {step === 1 ? 'Cancel' : 'Back'}
          </button>
          
          {step < 2 ? (
            <button
              type="button"
              onClick={handleNextStep}
              className="px-4 sm:px-6 py-2 text-sm sm:text-base bg-gradient-to-r from-blue-500 to-purple-500 text-white rounded-xl font-semibold hover:from-blue-600 hover:to-purple-600 transition-all"
            >
              Next
            </button>
          ) : (
            <div className="flex gap-2 sm:gap-3">
              <button
                type="button"
                onClick={handleAddToCart}
                disabled={isLoading}
                className="px-3 sm:px-6 py-1.5 sm:py-2 text-xs sm:text-base bg-gradient-to-r from-purple-500 to-blue-500 text-white rounded-lg sm:rounded-xl font-semibold hover:from-purple-600 hover:to-blue-600 transition-all disabled:opacity-50 flex items-center gap-1 sm:gap-2"
              >
                {isLoading ? (
                  <>
                    <svg className="animate-spin h-4 w-4 sm:h-5 sm:w-5" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none"/>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"/>
                    </svg>
                    <span className="hidden sm:inline">Processing...</span>
                    <span className="sm:hidden">...</span>
                  </>
                ) : (
                  <>
                    <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                    <span className="hidden sm:inline">Add to Cart</span>
                    <span className="sm:hidden">Cart</span>
                  </>
                )}
              </button>
              
              <button
                type="button"
                onClick={handlePurchase}
                disabled={isLoading}
                className="px-3 sm:px-6 py-1.5 sm:py-2 text-xs sm:text-base bg-gradient-to-r from-green-500 to-emerald-500 text-white rounded-lg sm:rounded-xl font-semibold hover:from-green-600 hover:to-emerald-600 transition-all disabled:opacity-50 flex items-center gap-1 sm:gap-2"
              >
                {isLoading ? (
                  <>
                    <svg className="animate-spin h-4 w-4 sm:h-5 sm:w-5" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none"/>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"/>
                    </svg>
                    <span className="hidden sm:inline">Processing...</span>
                    <span className="sm:hidden">...</span>
                  </>
                ) : (
                  <>
                    <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                    </svg>
                    {productType === 'credits' ? (
                      <span>Payment</span>
                    ) : (
                      <>
                        <span className="hidden sm:inline">Shipping + Payment</span>
                        <span className="sm:hidden">Checkout</span>
                      </>
                    )}
                  </>
                )}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};

export default GiftCardPurchaseModal;
